export const en = {
  common: {
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    loading: 'Loading...',
    success: 'Success',
    error: 'Error',
    retry: 'Retry',
  },
  app: {
    Home: 'Home',
    Create: 'Create',
    Projects: 'Projects',
    Templates: 'Templates',
    LivePreview: 'Live Preview',
    Resource: 'Resource',
    Assets: 'Assets',
    Tool: 'Tool',
    AllTools: 'All Tools',
    Settings: 'Settings',
    logout: 'Log out',
    Feedback: 'Feedback',
    Support: 'Support',
    profile: 'Profile',
    Workspace: 'Workspace',
    accountSettings: 'Account Settings',
    generationHistory: 'Generation History',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    invite: 'Invite Friends',
    RedemptionCode: 'Redemption code',
    APIKeys: 'API Keys',
    getMoreCredits: 'Get More Credits',
    earnCredits: 'Earn Credits',
    inviteFriends: 'Invite Friends',
    referralProgram: 'Referral Program',
    creditsEarned: 'Credits Earned',
    shareToEarn: 'Share to Earn Credits',
    dailyRewards: 'Daily Rewards',
    completeProfile: 'Complete Profile',
    creditsRemaining: 'Credits Remaining:',
    upgrade: 'Upgrade',
    clickToAccess: 'Click to access',
    account: 'Account',
    claimFreeCredits: 'Claim Free Credits',
    claimed: 'Claimed',
  },
  dailyCredits: {
    success: {
      title: 'Success',
      description: 'Daily credits claimed successfully!',
    },
    error: {
      title: 'Error',
      description: 'Failed to claim credits',
    },
  },
  design: {
    styleBrush: 'Style brush',
    clear: 'Clear',
    fill: 'Fill',
    group: 'Group',
    Ungroup: 'Ungroup',
    background: 'Background',
    replace: 'Replace',
    replaceImage: 'Replace Image',
    generateImage: 'Generate Image using AI',
    generate: 'AI Generate',
    editImage: 'Edit',
    imageSearch: 'Search Images',
    processing: 'Processing...',
    recents: 'Recents',
    assets: 'Assets',
    qrcode: 'QR Code',
    icon: 'Icon',
    uploadImage: 'Upload Image',
    opacity: 'Opacity',
    radius: 'Radius',
    rotation: 'Rotation',
    border: 'Border',
    position: 'Position & Dimensions',
    dimensions: 'Dimensions',
    shadow: 'Shadow',
    password: {
      title: 'Password Required',
      description: 'This project is password protected. Please enter the password to access it.',
      placeholder: 'Enter password',
      submit: 'Submit',
      cancel: 'Cancel',
      invalidPassword: 'Invalid password',
    },
    leave: {
      generating:
        'Project is currently being generated. Leaving may interrupt the generation. Are you sure you want to leave?',
      unsaved: 'You have unsaved changes. Are you sure you want to leave?',
    },
    shadowPanel: {
      color: 'Color',
      parameters: 'Parameters',
      presets: 'Presets',
      none: 'None',
      blur: 'Blur',
      spread: 'Spread',
    },
    flipPanel: {
      flip: 'Flip',
      horizontal: 'Horizontal',
      vertical: 'Vertical',
      flipHorizontal: 'Flip Horizontal',
      flipVertical: 'Flip Vertical',
    },
    framePresetPanel: {
      presets: 'Presets',
      colorPresets: 'Color Presets',
      imagePresets: 'Image Presets',
      texture: 'Texture',
      abstract: 'Abstract',
      showLess: 'Show less',
      showMore: 'Show more',
    },
    framePanel: {
      pageSettings: 'Page Settings',
      presets: 'Presets',
      effects: 'Effects',
      colorPresets: 'Color Presets',
      imagePresets: 'Image Presets',
      texture: 'Texture',
      abstract: 'Abstract',
      noise: 'Noise',
      blur: 'Blur',
    },
    export: 'Export',
    rotatePanel: {
      rotate: 'Rotate',
      rotation: 'Rotation',
      rotate90: 'Rotate 90°',
    },
    backdropFilter: 'Backdrop Filter',
    backdropPanel: {
      none: 'None',
      'grayscale(100%)': 'Grayscale',
      'sepia(100%)': 'Sepia',
      'blur(5px)': 'Blur',
      'brightness(150%)': 'Brightness',
      'contrast(150%)': 'Contrast',
      'invert(100%)': 'Invert',
      'saturate(200%)': 'Saturate',
    },
    textAlignPanel: {
      textAlignment: 'Text Alignment',
      horizontalAlignment: 'Horizontal Alignment',
      verticalAlignment: 'Vertical Alignment',
      alignLeft: 'Align Left',
      alignCenter: 'Align Center',
      alignRight: 'Align Right',
      alignJustify: 'Align Justify',
      alignTop: 'Align Top',
      alignMiddle: 'Align Middle',
      alignBottom: 'Align Bottom',
    },
    dashPanel: {
      lineStyle: 'Line Style',
      style: 'Style',
      solid: 'Solid',
      dashed: 'Dashed',
      dotted: 'Dotted',
      dashDot: 'Dash-Dot',
      dashDotDot: 'Dash-Dot-Dot',
      custom: 'Custom',
      mixed: 'Mixed',
      customPattern: 'Custom Pattern',
      example: 'e.g: 5,5',
    },
    lineSize: {
      lineThickness: 'Line Thickness',
    },
    lineStylePanel: {
      lineCap: 'Line Cap',
      lineJoin: 'Line Join',
      butt: 'Butt',
      round: 'Round',
      square: 'Square',
      miter: 'Miter',
      bevel: 'Bevel',
    },
    Custom: 'Custom',
    Presets: 'Presets',
    letterSpacing: 'Letter Spacing',
    lineHeight: 'Line Height',
    padding: {
      padding: 'Padding',
      top: 'Top',
      bottom: 'Bottom',
      left: 'Left',
      right: 'Right',
    },
    save: 'Save',
    textSettings: 'Text Settings',
    groupSettings: 'Group Settings',
    lineSettings: 'Line Settings',
    children: 'Children',
    mixedNode: 'Mixed Node',
    variableLabel: 'Variable label',
    textStyle: 'Text Style',
    fontFamily: 'Font family',
    fontSize: 'Font size',
    fontWeight: 'Font weight',
    textAlignment: 'Text Alignment',
    highlight: 'Highlight',
    stroke: 'Stroke',
    effect: 'Effect',
    filter: 'Filter',
    color: 'Color',
    size: 'Size',
    decoration: 'Decoration',
    spacing: 'Spacing',
    effects: 'Effects',
    clearEffects: 'Clear Effects',
    highlightTip: 'Select text first, then apply highlight styles',
    advancedSettings: 'Advanced Settings',
    strokeWidth: 'Stroke Width',
    verticalAlign: 'Vertical Align',
    horizontalAlign: 'Horizontal Align',
    alignTop: 'Align Top',
    alignMiddle: 'Align Middle',
    alignBottom: 'Align Bottom',
    alignLeft: 'Align Left',
    alignCenter: 'Align Center',
    alignRight: 'Align Right',
    font: {
      allFonts: 'All Fonts',
      Chinese: 'Chinese Fonts',
      English: 'English Fonts',
      fontStyles: 'Font Styles',
      language: 'Language',
      searchFonts: 'Search fonts...',
    },
    pageSettings: 'Page Settings',
    solid: 'Solid',
    gradient: 'Gradient',
    image: 'Image',
    presets: 'Presets',
    noise: 'Noise',
    blur: 'Blur',
    overlay: 'Overlay',
    clipPath: 'Clip Path',
    imageSettings: 'Image Settings',
    objectFit: 'Object Fit',
    bgRemover: 'BG Remover',
    crop: 'Crop',
    imageStyle: 'Image Style',
    imageFilter: 'Image Filter',
    imageSource: 'Image Source',
    backgroundRemoval: 'Background Removal',
    imageUpscale: 'Image Upscale',
    enhanceImageQuality: 'Enhance image quality and resolution',
    imageEditing: 'Image Editing',
    cropDescription: 'Resize and reframe your image',
    removeObjects: 'Remove Objects',
    imageInpaint: 'Paint over unwanted objects',
    borderColor: 'Border Color',
    borderWidth: 'Border Width',
    rotate: 'Rotate',
    textEffect: 'Text Effect',
    textHighlight: 'Text Highlight',
    applyHighlight: 'Apply Highlight',
    highlightColor: 'Highlight Color',
    highlightStyle: 'Highlight Style',
    highlightOpacity: 'Highlight Opacity',
    textDecoration: 'Text Decoration',
    underline: 'Underline',
    strikethrough: 'Strikethrough',
    italic: 'Italic',
    bold: 'Bold',
    shape: 'Shape',
    moreOptions: 'More Options',
    patternColor: 'Pattern Color',
    patternSize: 'Pattern Size',
    applyPattern: 'Apply Pattern',
    glassLight: 'Glass Light',
    default: 'Default',
    filterIntensity: 'Filter Intensity',
    glassBlack: 'Glass Black',
    outline: 'Outline',
    shadowOptions: 'Shadow Options',
    shadowNone: 'None',
    shadowSmall: 'Small',
    shadowMedium: 'Medium',
    shadowLarge: 'Large',
    shadowXLarge: 'X-Large',
    shadowInner: 'Inner',
    shadowSoft: 'Soft',
    shadowHard: 'Hard',
    shadowOffset: 'Offset',
    shadowSpread: 'Spread',
    customShadow: 'Custom Shadow',
    // Image filters
    filters: {
      Binarize: 'Binarize',
      Brightness: 'Brightness',
      Gamma: 'Gamma',
      Sharpen: 'Sharpen',
      Solarize: 'Solarize',
      GrayScale: 'Grayscale',
      GaussianBlur: 'Gaussian Blur',
    },
    rembg: 'Remove Background',
    removeBackground: 'Remove Background',
    tools: {
      undo: 'Undo',
      redo: 'Redo',
      showPages: 'Show pages',
      selectionMode: 'Selection Mode',
      handTool: 'Hand tool',
      defaultSelectionMode: 'Select',
      deepSelectionMode: 'Deep Select',
      zoomToFit: 'zoom To Fit',
      zoomIn: 'zoom In',
      zoomOut: 'zoom Out',
      addText: 'Add Text',
      addImage: 'Add Image',
      addRectangle: 'Add Rectangle',
      addCircle: 'Add Circle',
      addIcon: 'Add Icon',
      addQRCode: 'Add QR Code',
      text: 'Text',
      image: 'Image',
      shape: 'Shape',
      rectangle: 'Rectangle',
      circle: 'Circle',
      icon: 'Icon',
      qrCode: 'QR Code',
      dragAndDrop: 'Drag and drop to canvas',
      clickToAdd: 'Click to add',
    },
    inserts: {
      rectangle: 'Rectangle',
      circle: 'Circle',
      triangle: 'Triangle',
      star: 'Star',
      line: 'Line',
      image: 'Image',
      icon: 'Icon',
      qrcode: 'QR Code',
      heading1: 'Heading 1',
      heading2: 'Heading 2',
      bodyText: 'Body Text',
      quote: 'Quote',
      upload: 'Upload',
      or: 'or',
      imageUrl: 'Image URL',
      imageUrlPlaceholder: 'https://example.com/image.jpg',
      add: 'Add',
    },

    // Shadow options
    shadowCustom: 'Custom',
    shadowColor: 'Shadow Color',
    shadowBlur: 'Shadow Blur',
    shadowDistance: 'Shadow Distance',
    shadowAngle: 'Shadow Angle',

    // Image styles
    imageStyleDefault: 'Default',
    imageStyleGlassLight: 'Glass Light',
    imageStyleGlassBlack: 'Glass Black',
    imageStyleOutline: 'Outline',

    // Filter effects
    filterNone: 'None',
    filterVintage: 'Vintage',
    filterSepia: 'Sepia',
    filterDramatic: 'Dramatic',
    filterSharp: 'Sharp',
    filterCool: 'Cool',
    filterWarm: 'Warm',
    publish: {
      title: 'Share design',
      publishDescription: 'Share your design with the community',
      selectPage: 'Select Page',
      choosePage: 'Choose a page',
      page: 'Page',
      name: 'Name',
      description: 'Description',
      tags: 'Tags',
      tagPlaceholder: 'Enter tag',
      publish: 'Publish',
      update: 'Update',
      uploading: 'Uploading...',
      success: {
        title: 'Template Shared Successfully',
        description: 'Your template is now available in the community gallery',
      },
      error: {
        title: 'Unable to Share Template',
        description: 'Something went wrong. Please check your connection and try again.',
      },
      projectPermissions: 'Access level',
      publishTemplate: 'Publish template',
      visibility: 'Project Visibility',
      public: 'Public',
      publicDescription: 'Anyone can view this project in the community gallery',
      private: 'Private',
      privateDescription: 'Only you and people you share with can access this project',
      updating: 'Updating...',
      updatePermissions: 'Update Permissions',
      shareLink: 'Share Link',
      copyLink: 'Copy Link',
      linkCopied: 'Link copied to clipboard!',
      embedCode: 'Embed Code',
      copyCode: 'Copy Code',
      codeCopied: 'Code copied to clipboard!',
      shareUrl: 'Share URL',
      shareUrlPublicDesc: 'Anyone with this link can view your project',
      shareUrlPrivateDesc: 'Only you can access this project with this link',
      publicAccess: 'Public Access',
      privateAccess: 'Private Access',
      urlWillAppearHere: 'URL will appear here',
      urlReady: 'URL is ready',
      urlNotReady: 'URL not available',
      copy: 'Copy',
      copySuccess: 'Copied!',
      copySuccessDesc: 'Share URL has been copied to clipboard',
      copyFailed: 'Copy failed',
      copyFailedDesc: 'Failed to copy URL to clipboard',
      accessPassword: 'Access Password',
      accessPasswordPlaceholder: 'Set access password (optional)',
      accessPasswordDesc: 'Visitors will need this password to view your project',
      share: 'Share',
      accessLevel: 'Access Level',
      anyoneWithLink: 'Anyone with the link',
      canView: 'Can view',
    },
    blendPanel: {
      blendMode: 'Blend Mode',
      mixed: 'Mixed',
      normal: 'Normal',
      multiply: 'Multiply',
      screen: 'Screen',
      overlay: 'Overlay',
      darken: 'Darken',
      lighten: 'Lighten',
      colorDodge: 'Color Dodge',
      colorBurn: 'Color Burn',
      hardLight: 'Hard Light',
      softLight: 'Soft Light',
      difference: 'Difference',
      exclusion: 'Exclusion',
      hue: 'Hue',
      saturation: 'Saturation',
      color: 'Color',
      luminosity: 'Luminosity',
      desc: {
        normal: 'No blending, default mode.',
        multiply: 'Darkens by multiplying base and blend colors.',
        screen: 'Lightens by inverting, multiplying, and inverting again.',
        overlay: 'Combines multiply and screen for contrast.',
        darken: 'Keeps the darker color.',
        lighten: 'Keeps the lighter color.',
        colorDodge: 'Brightens the base color to reflect the blend color.',
        colorBurn: 'Darkens the base color to reflect the blend color.',
        hardLight: 'Combines multiply and screen based on blend color.',
        softLight: 'Soft subtle lighting effect.',
        difference: 'Subtracts darker from lighter color.',
        exclusion: 'Similar to difference but with lower contrast.',
        hue: 'Uses the hue of the blend color.',
        saturation: 'Uses the saturation of the blend color.',
        color: 'Uses the color of the blend color.',
        luminosity: 'Uses the luminosity of the blend color.',
      },
    },
    maskPanel: {
      mask: 'Mask',
      mixed: 'Mixed',
      none: 'None',
      alphaClip: 'Alpha Mask - Clip',
      alphaIntersect: 'Alpha Mask - Intersect',
      desc: {
        none: 'No mask applied.',
        alphaClip: 'Uses alpha channel to clip content.',
        alphaIntersect: 'Uses alpha channel to intersect content.',
      },
    },
    imageFitPanel: {
      objectFit: 'Object Fit',
      mixed: 'Mixed',
      cover: 'Cover',
      contain: 'Contain',
      fill: 'Fill',
      none: 'None',
      scaleDown: 'Scale Down',
      desc: {
        cover: 'Scale to fill, may crop',
        contain: 'Scale to fit completely',
        fill: 'Stretch to fill exactly',
        none: 'Original size, no scaling',
        scaleDown: 'Scale down to fit if larger',
      },
    },
    skewPanel: {
      skew: 'Skew',
      parameters: 'Parameters',
      presets: 'Presets',
      none: 'None',
      mixed: 'Mixed',
      x: 'Skew X',
      y: 'Skew Y',
      preview: 'Preview',
      applyPreset: 'Apply Preset',
      reset: 'Reset',
      custom: 'Custom',
      preset: 'Preset',
      // Preset names (should match SKEW_PRESETS keys)
      skewPreset: {
        none: 'None',
        italic: 'Italic',
        'slight-left': 'Slight Left',
        'slight-right': 'Slight Right',
        'slight-up': 'Slight Up',
        'slight-down': 'Slight Down',
        'diagonal-left': 'Diagonal Left',
        'diagonal-right': 'Diagonal Right',
        'extreme-left': 'Extreme Left',
        'extreme-right': 'Extreme Right',
        'perspective-left': 'Perspective Left',
        'perspective-right': 'Perspective Right',
        custom: 'Custom',
      },
      // Preset descriptions (for tooltips or accessibility)
      skewPresetDesc: {
        none: 'No skew applied.',
        italic: 'Classic italic style skew.',
        'slight-left': 'Slight skew to the left.',
        'slight-right': 'Slight skew to the right.',
        'slight-up': 'Slight skew upwards.',
        'slight-down': 'Slight skew downwards.',
        'diagonal-left': 'Diagonal skew to the top left.',
        'diagonal-right': 'Diagonal skew to the bottom right.',
        'extreme-left': 'Strong skew to the left.',
        'extreme-right': 'Strong skew to the right.',
        'perspective-left': 'Perspective skew to the left.',
        'perspective-right': 'Perspective skew to the right.',
        custom: 'Custom skew values.',
      },
      // UI labels and tooltips
      selectPreset: 'Select a preset',
      selected: 'Selected',
      setCustom: 'Set custom skew values',
      resetToNone: 'Reset skew to none',
      current: 'Current',
      skewPreview: 'Skew preview',
      skewXLabel: 'Horizontal skew (X axis)',
      skewYLabel: 'Vertical skew (Y axis)',
      skewXDesc: 'Adjust the horizontal skew angle.',
      skewYDesc: 'Adjust the vertical skew angle.',
      parametersTab: 'Adjust skew parameters',
      presetsTab: 'Choose from preset styles',
    },
  },
  actions: {
    Undo: 'Undo',
    Redo: 'Redo',
    Duplicate: 'Duplicate',
    Paste: 'Paste',
    Cut: 'Cut',
    Delete: 'Delete',
    Layer: 'Layer',
    Alignment: 'Alignment',
    SelectLayer: 'Select layer',
    CopyAs: 'Copy as',
    CopyasPNG: 'Copy as PNG',
    CopyasWebp: 'Copy as Webp',
    CopyasHTML: 'Copy as HTML',
    CopyAsRawHTML: 'Copy as Inline HTML',
    ImageCrop: 'Image Crop',
    Forward: 'Forward',
    Backward: 'Backward',
    BringToFront: 'Bring to Front',
    SendToBack: 'Send to Back',
    alignToPageTop: 'Align to Page Top',
    alignToPageLeft: 'Align to Page Left',
    alignToPageMiddle: 'Align to Page Middle',
    alignToPageCenter: 'Align to Page Center',
    alignToPageBottom: 'Align to Page Bottom',
    alignToPageRight: 'Align to Page Right',
    alignToTop: 'Align to Top',
    alignToBottom: 'Align to Bottom',
    alignToMiddle: 'Align to Middle',
    alignToCenter: 'Align to Center',
    alignToLeft: 'Align to Left',
    alignToRight: 'Align to Right',
    AddToLibrary: 'Add to Library',
    CopyTextStyle: 'Copy style',
    PasteTextStyle: 'Paste style',
    Advanced: 'Advanced',
    selectAll: 'Select all',
    SplitFrameSections: 'Split Frame Sections',
    MergeFrames: 'Merge frames',
    flipHorizontal: 'Flip Horizontal',
    flipVertical: 'Flip Vertical',
    Distribute: 'Distribute',
    DistributeHorizontal: 'Distribute Horizontal',
    DistributeVertical: 'Distribute Vertical',
    EqualSpacingHorizontal: 'Equal Spacing Horizontal',
    EqualSpacingVertical: 'Equal Spacing Vertical',
  },
  landing: {
    seoTitle: 'Seede AI - Simple, Fast, and Fun AI Graphic Design for Everyone',
    seoDescription:
      'Ideas into designs in 1 click! Seede AI creates social & marketing posts instantly. No software to learn – Try free!',
    seoKeywords:
      'seede, seede ai, AI poster, Free design tool no download,LinkedIn posts,AI poster generator, free design tools,easy design',
    featuresSubtitle: 'Powerful Features',
    featuresDescription:
      'How to use ai for graphic design? Seede ai offers a suite of powerful AI-powered tools to streamline your design workflow and help you create stunning visuals with ease.',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    recommendations: 'Recommendations',
    refresh: 'Refresh',
    productFeatures: 'Features',
    useCases: 'Use Cases',
    pricing: 'Pricing',
    products: 'Products',
    templates: 'Templates',
    getStarted: 'Get Started',
    tryForFree: 'Try For Free',
    heroTitle: `Your ideas. Designed in seconds.`,
    heroSubtitle: 'Pro Graphics Design Made Simple with Seede AI',
    learnMore: 'Learn More',
    browserAllTemplates: 'Browse All Templates',
    startUsing: 'Start Creating Free',
    whatIsSeede: 'What is Seede AI?',
    richTemplates: 'Rich AI Creative Templates',
    whyNotTry: 'Why not give it a try?',
    whatIsSeedeDesc: `Seede ai is an AI-powered design tool that helps you create stunning visuals in just one minute—no design skills needed. Perfect for social media content, marketing materials, and creative projects.`,
    mainFeatures: 'Core Features',
    createWithAI: 'Create with Seede AI, freely and instantly.',
    creationFromCommunity: 'Creation from community',
    creatorCount: 'Seede AI — Everyone can create professional designs and layouts with one click.',
    coreFeaturesBadge: 'Core features',
    coreFeature1: 'Keep Your Words and Structure Exactly as Intended',
    coreFeature1Desc:
      'Your content stays intact, every word, every structure, exactly as you intended.',
    coreFeature2: 'Auto-layout That Makes Any Content Look Designed',
    coreFeature2Desc: 'Transform any content into polished designs with intelligent auto-layout.',
    coreFeature3: 'Works Naturally with Any Language or Format',
    coreFeature3Desc: 'Seamlessly handle any language, document format, or content type.',
    freeTools: 'Free Image Processing Tools',
    ctaTitle: 'Experience Seede AI Design Today',
    ctaNow: 'Try Seede AI for free now.',
    ctaDesc:
      'Turn any content into polished, ready-to-use designs — while keeping every word, structure, and meaning.',
    startCreating: 'Start Creating',
    footerDesc:
      'Seede AI is an AI design tool that helps to turn you ideas into stunning visuals in seconds. No design skills needed. Perfect for social media content, marketing materials, and creative projects.',
    product: 'Products',
    features: 'Features',
    cases: 'Use Cases',
    resources: 'Resources',
    helpCenter: 'Help Center',
    docs: 'Documentation',
    company: 'Company',
    team: 'Team',
    affiliates: 'Affiliates',
    aboutUs: 'About',
    blog: 'Blog',
    contactUs: 'Contact',
    dashboard: 'Dashboard',
    tools: 'Tools',
    howItWorks: 'How It Works',
    howYouCanDesign: 'How you can design like a pro',
    createInFourSteps: 'Create stunning designs in just four simple steps',
    steps: {
      step1Title: 'Describe',
      step1Desc: 'Describe what you want to design.',
      step2Title: 'Create',
      step2Desc: 'Seede creates your first version.',
      step3Title: 'Improve',
      step3Desc: 'Improve it by asking for changes.',
      step4Title: 'Export',
      step4Desc: 'Export your design and publish or print.',
    },
    designSteps: {
      idea: {
        title: 'Just an idea',
        desc: 'Just start from any ideas in your mind. No matter how big or small it is.',
      },
      generate: {
        title: 'Generate',
        desc: "Type what's in your mind and just hit generate button",
      },
      seconds: {
        title: 'Just in seconds',
        desc: 'Wait for seconds, and the magic happens, you get a design like a pro.',
      },
      export: {
        title: 'Improve or Export',
        desc: 'Chatting while brainstorming with seede AI or export to use directly.',
      },
    },
    socialProof: '{{user}} creators are designing with Seede',
    // 新增翻译
    featureDesc: 'AI-powered professional design generation tool',
    featuresIntroStrong: 'Seede AI is an AI design tool',
    featuresIntroLight:
      ' that helps to turn your ideas into stunning polished designs in seconds for any content, any language, any format.',
    feature1: 'Complete the design <br/> in one minute',
    feature1Desc:
      'No design experience needed, create marketing designs for any industry in 1 minute',
    feature2: 'Generate designs <br/> from images and documents',
    feature2Desc: 'Upload images or documents directly, AI generates designs instantly',
    feature3: 'Seede AI at anytime, anywhere',
    feature3Desc: 'Generate elements with layered editing, AI-assisted partial optimization',
    tool1: 'Landscape to Portrait Video Tool',
    tool1Desc: 'Convert landscape videos to portrait format for social media',
    tool2: 'Background Removal',
    tool2Desc: 'One-click background removal',
    tool3: 'Magic Eraser',
    tool3Desc: 'Easily remove unwanted elements',
    tool4: 'Image Generation',
    tool4Desc: 'Generate images from text',
    tool5: 'Image Upscaling',
    tool5Desc: 'Enhance image resolution',
  },
  products: {
    posterGenerator: {
      title: 'Event Poster Generator',
      name: 'Event Poster',
      description: 'Quickly create professional event posters',
    },
    invitationGenerator: {
      title: 'Invitation Generator',
      name: 'Invitation Card',
      description: 'Create beautiful digital invitations',
    },
    infographicGenerator: {
      title: 'Infographic Generator',
      name: 'Infographic',
      description: 'Create visually appealing data-driven infographics',
    },
    newsletterGenerator: {
      title: 'Newsletter Generator',
      name: 'Newsletter',
      description: 'Create professional newsletter templates',
    },
    flashcardGenerator: {
      title: 'Flashcard Generator',
      name: 'Flashcard',
      description: 'Generate study flashcards',
    },
    socialMediaGenerator: {
      title: 'Social Media Post',
      name: 'Social Media Post',
      description: 'Create engaging social media content with Seede AI',
    },
    wechatCoverGenerator: {
      title: 'WeChat Cover Generator',
      name: 'WeChat Cover',
      description: 'Create eye-catching WeChat article covers with Seede AI',
    },
    eventPromotionGenerator: {
      title: 'Event Promotion Generator',
      name: 'Event Promotion',
      description: 'Design eye-catching event promotions and ads',
    },
    albumCoverGenerator: {
      title: 'Album Cover Generator',
      name: 'Album Cover',
      description: 'Design stunning music album covers with Seede AI',
    },
    signageGenerator: {
      title: 'Signage Generator',
      name: 'Signage',
      description: 'Create professional signage and display materials',
    },
    menuGenerator: {
      title: 'Restaurant Menu Generator',
      name: 'Restaurant Menu',
      description: 'Create visually stunning restaurant or cafe menus using Seede AI',
    },
    flyerGenerator: {
      title: 'Flyer Generator',
      name: 'Flyer',
      description:
        'Whether for lost pets, gallery openings, or fundraising events, create beautiful flyers with our easy-to-use tool',
    },
    scrollytellingGenerator: {
      title: 'Scrollytelling Generator',
      name: 'Scrollytelling',
      description:
        'Create visually compelling long-form content that perfectly showcases data stories and memorable moments, making your social media shares more engaging',
    },
    presentationGenerator: {
      title: 'Presentation Generator',
      name: 'Presentation',
      description: 'Create professional presentation slides with Seede AI',
    },
    multiPageBrochureGenerator: {
      title: 'Multi-Page Brochure Generator',
      name: 'Multi-Page Brochure',
      description: 'Create professional multi-page brochures with Seede AI',
    },
    diagramGenerator: {
      title: 'Diagram Generator',
      name: 'Diagram',
      description: 'Create professional diagrams and flowcharts with Seede AI',
    },
    pullUpBanner: {
      title: 'Pull Up Banner Generator',
      name: 'Pull Up Banner',
      description: 'Create professional pull up banners and standing displays with Seede AI',
    },
  },
  workspace: {
    templatesGroup: 'Templates',
    promptLibrary: 'Prompt Library',
    featuredDesigns: 'Featured Designs',
    ai: 'Seede AI',
    create: 'Create',
    createTitle: 'What do you want to design now?',
    morePromptTemplates: 'More prompt templates',
    allDesigns: 'All Designs',
    recentlyReviewed: 'Recently Reviewed',
    assets: 'Assets',
    themes: 'Themes',
    trash: 'Trash',
    orders: 'Billing',
    libraries: 'Libraries',
    settings: 'Settings',
    invite: 'Invite Friends',
    redeem: 'Redeem Code',
    newDesign: 'New Design',
    searchDesigns: 'Search designs...',
    sortBy: 'Sort by',
    all: 'All',
    recentlyViewed: 'Recently viewed',
    favorites: 'Favorites',
    recentlyUpdated: 'Recently Updated',
    oldestUpdated: 'Oldest Updated',
    recentlyCreated: 'Recently Created',
    oldestCreated: 'Oldest Created',
    noDesignsFound: 'No designs found',
    createFirstDesign: 'Create your first design to get started',
    loadingProjects: 'Loading projects...',
    deleteProject: 'Delete Project',
    confirmDelete: 'Are you sure you want to delete this project?',
    cancel: 'Cancel',
    delete: 'Delete',
    loadingMore: 'Loading more projects...',
    noProjectsFound: 'No projects found',
    createFirstProject: 'Create your first project to get started',
    newProject: 'New Project',
    searchProjects: 'Search projects...',
    loadingDesigns: 'Loading designs...',
    createNewDesign: 'Create New Design',
    welcomeTitle: 'Welcome to Your Workspace',
    welcomeDescription:
      'Start creating amazing designs with AI-powered tools. Your creativity has no limits.',
    createFirstDesignButton: 'Create Your First Design',
    recentWork: 'Recent Work',
    allProjects: 'All Projects',
    starredProjects: 'Starred Projects',
    viewAll: 'View All',
    emptyState: {
      title: 'No designs found',
      description: 'Create your first design to get started with AI-powered creativity',
      createButton: 'Create New Design',
    },
    filters: {
      all: 'All',
      recent: 'Recently viewed',
      favorites: 'Favorites',
      public: 'Public',
      private: 'Private',
    },
    sorting: {
      recentlyUpdated: 'Recently Updated',
      oldestUpdated: 'Oldest Updated',
      recentlyCreated: 'Recently Created',
      oldestCreated: 'Oldest Created',
      alphabetical: 'Alphabetical',
      reverseAlphabetical: 'Reverse Alphabetical',
    },
    actions: {
      open: 'Open',
      view: 'View',
      duplicate: 'Duplicate',
      rename: 'Rename',
      delete: 'Delete',
      share: 'Share',
      star: 'Star',
      unstar: 'Remove Star',
      moveToTrash: 'Move to Trash',
      restore: 'Restore',
      permanentDelete: 'Delete Permanently',
    },
    noSearchResults: 'No search results found',
    noSearchResultsDescription:
      "We couldn't find any designs matching '{{query}}'. Try adjusting your search terms.",
    clearSearch: 'Clear search',
    noFavorites: 'No favorites',
    noDesigns: 'No designs yet',
  },
  trash: {
    title: 'Trash',
    empty: {
      title: 'Trash is empty',
      description:
        "When you delete projects, they'll appear here for 30 days before being permanently removed.",
    },
    confirmPermanentDelete:
      'Are you sure you want to permanently delete this project? This action cannot be undone.',
    deletedAt: 'Deleted on',
    restoredSuccessfully: 'Project restored successfully',
    deletedPermanently: 'Project permanently deleted',
    failedToRestore: 'Failed to restore project',
    failedToDelete: 'Failed to permanently delete project',
  },
  settings: {
    title: 'Settings',
    description: 'Manage your account and application preferences',
    profile: {
      title: 'Profile',
      subtitle: 'Manage your account settings and preferences',
      profileSection: 'Profile',
      name: 'User name',
      email: 'Email',
      phone: 'Mobile',
      noEmail: 'Not set',
      noPhone: 'Not set',
      verified: 'Verified',
      cannotChange: 'Cannot change',
      avatar: 'Avatar',
      enterName: 'Enter your name',
      enterEmail: 'Enter your email',
      enterPhone: 'Enter your mobile number',
      save: 'Save',
      saving: 'Saving...',
      saveProfile: 'Save Profile',
      profileUpdated: 'Profile updated',
      profileUpdatedDesc: 'Your profile has been saved successfully',
      saveFailed: 'Save failed',
      saveFailedDesc: 'Failed to save your profile. Please try again.',
      changeAvatar: 'Change',
      uploadingAvatar: 'Uploading...',
      avatarUploadError: 'Failed to upload',
      avatarRequirements: 'JPG, PNG or WebP. Max 5MB.',
      avatarError: 'Avatar Error',
      avatarSizeError: 'Avatar image must be less than 5MB',
      uploadFailed: 'Upload Failed',
      uploadFailedDesc: 'Failed to upload avatar. Please try again.',
      avatarUpdated: 'Avatar Updated',
      avatarUpdatedDesc: 'Your avatar has been updated successfully',
      bindPhone: 'Bind',
      bindPhoneTitle: 'Bind Mobile Number',
      bindPhoneDesc: 'Enter your mobile number to receive a verification code',
      countryCode: 'Country Code',
      phoneNumber: 'Mobile Number',
      enterPhoneNumber: 'Enter mobile number',
      verificationCode: 'Verification Code',
      enterCode: 'Enter code',
      sendCode: 'Send',
      resend: 'Resend',
      sending: 'Sending...',
      binding: 'Binding...',
      confirm: 'Confirm',
      phoneRequired: 'Mobile number is required',
      invalidPhone: 'Invalid mobile number format',
      invalidPhoneDesc: 'Please enter a valid mobile number',
      codeSent: 'Verification code sent',
      codeSentDesc: 'Please check your mobile for the code',
      sendCodeFailed: 'Failed to send verification code',
      sendCodeFailedDesc: 'Please try again',
      fillAllFields: 'Please fill all fields',
      phoneBindSuccess: 'Mobile number bound successfully',
      bindPhoneFailed: 'Failed to bind mobile number',
      bindPhoneFailedDesc: 'Please try again',
      countries: {
        china: 'China',
        usa: 'USA',
        uk: 'UK',
        japan: 'Japan',
        korea: 'Korea',
      },
    },
    security: {
      title: 'Security',
      password: 'Password',
      passwordDesc: '••••••••',
      changePassword: 'Change',
      deleteAccount: 'Delete Account',
      deleteAccountDesc: 'Permanently delete your account and all data',
      delete: 'Delete',
      deleteAccountWarning:
        'This action cannot be undone. All your data will be permanently deleted.',
      deleteAccountConfirm: 'Please type your email to confirm:',
      confirmEmail: 'Email Confirmation',
      enterEmail: 'Enter your email',
      enterPassword: 'Enter your password',
      deleting: 'Deleting...',
    },
    notifications: {
      title: 'Notifications',
      email: 'Email Notifications',
      emailDesc: 'Receive notifications via email',
      desktop: 'Desktop Notifications',
      desktopDesc: 'Show desktop notifications',
      marketing: 'Marketing Emails',
      marketingDesc: 'Receive product updates and tips',
    },
    preferences: {
      title: 'Preferences',
      language: 'Language',
      theme: 'Theme',
      savePreferences: 'Save Preferences',
      settingsSaved: 'Settings saved',
      settingsSavedDesc: 'Your preferences have been updated successfully',
      saveFailedDesc: 'Failed to save your settings. Please try again.',
      autoSaved: 'Auto saved',
      languageChanged: 'Language Changed',
      languageChangedDesc: 'Language has been updated',
    },
    account: {
      title: 'Account',
      changePassword: 'Change Password',
      changePasswordDesc: 'Update your account password',
      deleteAccount: 'Delete Account',
      deleteAccountDesc: 'Permanently delete your account',
    },
  },
  pricing: {
    title: 'Start Your Design Journey with Seede AI',
    getStarted: 'Get Started',
    designBeginner: 'Design Beginner',
    loveDesign: 'Love Design Enthusiast',
    designLikeAPro: 'Design Like a Professional',
    designExpert: 'Design Expert',
    subscribe: 'Try for Free',
    popular: 'Popular',
    freePlan: 'Free Edition',
    freePlanDesc: 'Basic features for individual users',
    freeFeatures: [
      '5 credits every day (refreshes at 05:00)',
      'New users get extra 10 credits (never expire)',
      '5-10 AI generations or edit sessions',
      'Unlimited manual edits and exports',
      'Newcomer benefits:',
      'Invite friends, both get extra credits',
      'Full-featured editor',
      'Text: freely editable, adjustable, and deletable',
      'Images: upload/replace, AI edit (credits consumed)',
      'Access to large template library',
      'Text processing limit: 500 characters',
      'Upload up to 3 images per design',
      'PDF/Word import supported (max 5MB)',
      'Up to 5 pages per generation',
      'Standard export (with watermark)',
      'PNG / JPG / WebP exports supported',
    ],
    starterPlan: 'Starter Edition',
    starterPlanDesc: 'Best for quick experience & watermark removal',
    starterFeatures: [
      '5 credits every day (refreshes at 05:00)',
      'Purchase 50 credits (valid 12 months)',
      '25-50 AI generations or edit sessions',
      'Unlimited manual edits and exports',
      'All "Design Beginner" benefits, plus:',
      'Unlock "Private Generation"',
      'Fonts/images can be used commercially',
      'Text processing limit: 3000 characters',
      'Upload up to 20 images per design',
      'PDF/Word import supported (max 15MB)',
      'Up to 10 pages per generation',
      'HD export (no watermark)',
      'Supports export: PDF / PPT / HTML',
    ],
    proPlan: 'Pro Edition',
    proPlanDesc: 'Top value · More credits, more power, priority features',
    proFeatures: [
      '5 credits every day (refreshes at 05:00)',
      'Purchase 300 credits (valid 12 months)',
      '150-300 AI generations or edit sessions',
      'Unlimited manual edits and exports',
      'All "Love Design Enthusiast" benefits, plus:',
      'Text processing limit: 5000 characters',
      'Up to 20 pages per generation',
      'Priority access to new features',
      'Early access to advanced AI models',
    ],
    tryNow: 'Buy Now',
    choosePlan: 'Unlock pro design superpowers and let your creativity shine.',
    0: {
      creditsPack: '0 AI Credits Pack',
      creditsPackDesc: 'For newcomers · Quick Try',
      tips: 'Perfect for simple projects, explore the power of Seede AI',
      creditsFeatures: [
        '5 credits per day (refresh at 05:00)',
        'New users get extra 10 credits (valid for 1 year)',
        '5-10 AI generations or edits',
        'Unlimited manual edit/export',
        'Newcomer rights:',
        'Invite friends, both get extra credits',
        'Full-featured editor',
        'Text: freely edit, adjust, or delete',
        'Images: upload/replace, supports AI edit (uses credits)',
        'Library of high-quality templates',
        'Up to 500 characters per design',
        'Up to 3 images per design',
        'PDF/Word import (max 5MB)',
        'Up to 5 pages per generation',
        'Standard export (with watermark)',
        'Export as PNG / JPG / WebP',
      ],
    },
    50: {
      creditsPack: '50 AI Credits Pack',
      creditsPackDesc: 'For newcomers · Quick Try',
      tips: 'Remove watermark and unlock advanced features',
      creditsFeatures: [
        '5 credits per day (refresh at 05:00)',
        'Buy 50 credits (valid 12 months)',
        '25-50 AI generations or edits',
        'Unlimited manual edit/export',
        'All "Design Beginner" rights, plus:',
        'Unlock "Private Generation"',
        'Fonts/images allowed for commercial use',
        'Up to 3000 characters per design',
        'Up to 20 images per design',
        'PDF/Word import (max 15MB)',
        'Up to 10 pages per generation',
        'HD export (no watermark)',
        'Export as PDF / PPT / HTML',
      ],
    },
    300: {
      creditsPack: '300 AI Credits Pack',
      creditsPackDesc: 'Top Pick · Best Value',
      tips: 'Enjoy higher limits, stronger models, and priority try-outs',
      creditsFeatures: [
        '5 credits per day (refresh at 05:00)',
        'Buy 300 credits (valid 12 months)',
        '150-300 AI generations or edits',
        'Unlimited manual edit/export',
        'All "Love Design Enthusiast" rights, plus:',
        'Up to 5000 characters per design',
        'Up to 20 pages per generation',
        'Priority beta access to new features',
        'Early access to better AI models',
      ],
    },
    100: {
      creditsPack: '100 AI Credits Pack',
      creditsPackDesc: 'Enterprise Choice · Pro Edition',
      tips: '300 credits for 150 advanced model generations or editings, or 300 standard model generations/editings',
      creditsFeatures: ['300 credits (valid 1 month)', 'All features from 39.9 CNY tier'],
    },
    tips: 'Enjoy {{count}} professional design experiences',
    comingSoon: 'Coming Soon',
    perMonth: '/month',
    betaNoticeTitle:
      'Thanks to every user who gave sincere feedback during Seede AI’s beta. Based on your insights, we made price adjustments, effective immediately:',
    betaNoticeItems: [
      {
        description:
          'Added a "Design Beginner" Free Plan: receive 5 free credits daily, access most Seede AI features.',
      },
      {
        description: 'The original "10 RMB" plan has been merged into the former "21 RMB" plan.',
      },
    ],
    testimonials: {
      title: 'User Testimonials',
      subtitle: 'Seede AI helps users create stunning designs—and they love it.',
    },
    stats: {
      activeUsers: 'Active Users',
      designsCreated: 'Designs Created',
      satisfactionRate: 'Satisfaction Rate',
    },
    faq: {
      title: 'FAQ',
      subtitle: "Answers about Seede AI's pricing and usage",
      productHighlights: 'Product highlights include:',
      items: [
        {
          question: 'What is Seede AI?',
          answer:
            'Seede AI is an AI design tool that helps you produce editable, professional designs in just one minute. No design experience needed—just input your text and optionally images, and instantly generate beautiful layouts for e-commerce pages, social posts, policy info, banners, science infographics, event agendas, course posters, and more.',
          link: {
            text: 'See examples designed with Seede AI',
            url: 'https://seedesign.feishu.cn/wiki/S65OwuCLSiCm2qkZHUhccFVJnGg',
          },
          highlights: [
            'Content-first: keeps your input text and structure 100% intact, and presents them in a visually appealing way.',
            'Fully editable, easily replace text or images: after generation, you’re free to edit, adjust, replace, or delete everything.',
            'Supports 100+ languages & formats: keeps text and layout accurate—globally compatible and multi-lingual.',
          ],
        },
        {
          question: 'What’s the difference between the Free and Paid plans?',
          answer:
            'Free: Get 5 credits daily, full editor access, and community templates. Export is standard (includes watermark).',
          answerAfterLink:
            'Paid: Unlock more—HD exports (no watermark), more export formats, commercial licenses, and higher text/image limits.',
        },
        {
          question: 'What are "credits" in Seede AI?',
          answer:
            'Credits are Seede AI’s core currency. Generating or re-editing with the "Advanced Model" costs 2 credits; with "Standard Model", 1 credit. Batch generation multiplies credits used. For example, generating 4 designs at once with Advanced Model consumes 8 credits.',
          subItems: [
            'Advanced Models: Gemini 3 Pro (default), Gemini 2.5 Pro, Claude 4.5, GPT-5, etc.',
            'Standard Models: Gemini 2.5 Flash, Kimi K2, GPT-5 mini, Qwen3, Deepseek V3, GLM 4.6, Doubao, MiniMax, and more',
          ],
        },
        {
          question: 'How can I get more credits?',
          answer: 'There are 5 main ways to get credits:',
          subItems: [
            'New users: extra 10 credits as a gift',
            'Daily login: get 5 credits (refresh at 05:00)',
            'Invite friends, both get 5 credits',
            'Buy credits',
            'Join special events for bonus credits',
          ],
        },
        {
          question: 'Do credits expire?',
          answer: 'Yes. Different credits have different validity periods:',
          subItems: [
            'New user gift credits: valid for 1 year',
            'Daily login credits: refreshed daily at 05:00',
            'Referral credits: valid for 12 months',
            'Purchased credits: valid for 12 months, cannot be extended or transferred',
            'Event bonus credits: validity specified by event rules',
          ],
        },
        {
          question: 'How are credits consumed?',
          answer: 'Credits are used in the following order:',
          subItems: [
            'Event bonus credits',
            'Daily credits',
            'Referral (invite) credits',
            'New user bonus credits',
            'Purchased credits',
          ],
        },
        {
          question: 'How do I invite friends and get credit rewards?',
          answer: 'Go to:',
          link: {
            text: 'Invite Friends',
            url: 'https://seede.ai/invite',
          },
          answerAfterLink:
            'Share your invite link. When your friend registers and creates their first design, you both get 5 credits.',
        },
        {
          question: 'Who owns the designs I create on Seede AI?',
          answer:
            'All your design source files and projects belong 100% to you. Seede AI strictly follows data privacy policies; we cannot access or use your content without your permission.',
        },
        {
          question: 'Can I use my creations for commercial purposes?',
          answer: 'Free plan: for personal and non-commercial use only.',
          answerAfterLink:
            'Paid plans: Any work generated while your credits are valid is licensed for commercial use, including fonts and media assets.',
        },
        {
          question: 'Are there student/education discounts?',
          answer: 'Not yet—potentially in the future.',
        },
        {
          question: 'How do I cancel a subscription or get a refund?',
          answer:
            'Within 3 calendar days after payment, if your unused credits meet the criteria below, you can request a full refund.',
          table: {
            headers: ['Plan', 'Price', 'Eligible credit for full refund (≥)'],
            rows: [
              ['Love Design Enthusiast', '¥ 21', '40'],
              ['Design Expert', '¥ 99.99', '280'],
            ],
          },
          answerAfterTable: 'If you qualify, please',
          link: {
            text: 'Contact Us',
            url: 'https://seede.ai/contact',
          },
          answerAfterLink: 'and submit your refund request. We will process it promptly.',
        },
        {
          question: 'How can I contact the Seede team?',
          answer: 'Visit:',
          link: {
            text: 'Contact Us',
            url: 'https://seede.ai/contact',
          },
        },
      ],
    },
  },
  library: {
    title: 'My Libraries',
    description: 'Manage and organize your design collections',
    noLibrariesFound: 'No Libraries Found',
    noLibrariesDescription: 'Create your first library to start organizing your designs',
    untitledLibrary: 'Untitled Library',
    noDescription: 'No description',
    created: 'Created',
    loading: 'Loading libraries...',
    edit: 'Edit Library',
    create: 'Create Library',
    delete: 'Delete Library',
    name: 'Library Name',
    type: 'Type',
    editDescription: 'Description',
    category: 'Category',
    tag: 'Tags',
    html: 'HTML Content',
    save: 'Save Library',
    cancel: 'Cancel',
    confirmDelete: 'Are you sure you want to delete this library?',
    deleteSuccess: 'Library deleted successfully',
    createSuccess: 'Library created successfully',
    updateSuccess: 'Library updated successfully',
    errorLoading: 'Failed to load libraries',
  },
  libraryView: {
    backToLibraries: 'Back to Libraries',
    libraryItems: 'Library Items',
    browseItems: 'Browse items in this collection',
    emptyLibrary: 'This library is empty',
    addFirstDesign: 'Add your first design to this library',
    untitledItem: 'Untitled Item',
    loading: 'Loading library items...',
    editItem: 'Edit Item',
    deleteItem: 'Delete Item',
    confirmDelete: 'Are you sure you want to delete this item?',
    itemDeleted: 'Item deleted successfully',
    itemUpdated: 'Item updated successfully',
    errorLoading: 'Failed to load library items',
  },
  create: {
    title: 'Make a {dynamicText} in a Minute!',
    makeA: 'Make a',
    inAMinute: 'in a Minute!',
    createTitle: 'What do you want to design now?',
    generating: 'Generating...',
    promptLoading: 'Please wait a moment while your design is being created...',
    dynamicTexts: {
      Poster: 'Poster',
      Banner: 'Banner',
      Thumbnail: 'Thumbnail',
      PPT: 'PPT',
      Meme: 'Meme',
    },
    dynamicPlaceholders: [
      'Design a minimalist restaurant menu highlighting signature dishes and promotions...',
      'Create a travel destination poster. Destination is Inner Mongolia desert starry sky, 3 days 2 nights, summer activity...',
      'Design an event poster divided into two visual layers: "background image" and "foreground text layout". Text layout style: modernist style...',
      'Create a vocal course poster. Include 5-week course content, $4999, instructor introduction (photo)...',
    ],
    library: {
      title: 'Library',
      manage: 'Manage Libraries',
      select: 'Select a library to preview items',
      selectAll: 'Select All',
      deselectAll: 'Deselect All',
      itemCount: '{{selected}}/{{total}}',
      noLibraries: 'No libraries found',
      preview: 'Preview',
      clickToSelect: 'Click to select',
      itemSelected: 'Item selected',
      itemsSelected: 'Items selected',
      addToDesign: 'Add to Design',
      removeFromDesign: 'Remove from Design',
      dragToCanvas: 'Drag to canvas',
      searchPlaceholder: 'Search library items...',
      createNew: 'Create New Library',
      deleteLibrary: 'Delete Library',
      editLibrary: 'Edit Library',
      confirmDelete: 'Are you sure you want to delete this library?',
      libraryDeleted: 'Library deleted successfully',
      libraryCreated: 'Library created successfully',
      libraryUpdated: 'Library updated successfully',
    },
    esmNotSupportedTitle: 'Browser Not Supported',
    esmNotSupportedDesc:
      'Your browser does not support the required features. Please use a modern browser like Chrome, Edge, or Safari.',
    inputRequired: 'Input Required',
    inputRequiredDesc: 'Please provide a text description or upload an image to continue',
    projectCreationFailed: 'Project Creation Failed',
    projectCreationErrorDesc: 'An error occurred while creating the project. Please try again.',
    tryAgain: 'Try Again',
    uploadImage: 'Reference Image',
    attach: 'Attach',
    attachTips:
      'Add attachments - Upload reference images, materials, or documents to enhance your design',
    addMaterial: 'Add Material',
    addMaterialTips: 'Add image materials to design',
    giveInspirationPrompt: 'Get Inspiration',
    dynamicTextOptions: ['Poster', 'Banner', 'Meme'],
    generate: 'Generate',
    singleMode: 'Single',
    batchMode: 'Batch',
    generateBatch: 'Generate Batch',
    promptPlaceholder: 'Describe the design you want (e.g., "A modern coffee shop poster")',
    modelLabel: 'Select Model:',
    sizeLabel: 'Select Size:',
    presetTitle: 'Or choose a preset prompt:',
    use: 'Use',
    usePrompt: 'Use Prompt',
    loginRequired: 'Login Required',
    loginMessage: 'Welcome to Seede AI',
    continueWithEmail: 'Continue with Email',
    continueWithPhone: 'Continue with Phone',
    loginButton: 'Log In',
    registerButton: 'Register',
    maybeLater: 'Maybe Later',
    referenceUrl: 'Reference URL',
    enterReferenceUrl: 'Enter reference URL',
    colorScheme: 'Color Scheme',
    deviceNotSupportedTitle: 'Mobile Generation Not Supported',
    deviceNotSupportedDesc:
      'For the best experience, please use a computer. Mobile devices are not currently supported.',
    multimodal: 'Multimodal',
    whatToCreateToday: 'What would you like to create today?',
    designDimensions: 'Design Dimensions',
    sizes: {
      auto: 'Auto',
      height: 'Height',
      width: 'Width',
      custom: 'Custom',
      wechatMpCover: 'WeChat Official Account Cover',
      mobilePoster: 'Mobile',
      redNote: 'Xiaohongshu Post',
      newsletter: 'Newsletter',
      infographic: 'Infographic',
      instagram: 'Instagram',
      facebook: 'Facebook',
      twitter: 'X (Twitter)',
      linkedin: 'LinkedIn Post',
      pinterest: 'Pinterest',
      youtube: 'YouTube Thumbnail',
      tvScreen: 'TV Screen',
      a2: 'A2',
      a3: 'A3',
      a4: 'A4',
      a5: 'A5',
      a2h: 'A2 (Landscape)',
      a3h: 'A3 (Landscape)',
      a4h: 'A4 (Landscape)',
      a5h: 'A5 (Landscape)',
      businessCard: 'Business Card',
      postcard: 'Postcard',
      flyer: 'Flyer',
      brochure: 'Brochure',
      poster: 'Poster',
      banner: 'Banner',
      billboard: 'Billboard',
      menu: 'Menu',
      rollUpBanner: 'Roll-up Banner | 80×200cm',
      tableCard10x15: 'Table Card | 10×15cm',
      tableCard15x20: 'Table Card | 15×20cm',
      lightBoxPoster: 'Light Box Poster | 60×90cm',
    },
    custom_size: {
      title: 'Create Custom Size',
      name: 'Name (Optional)',
      name_placeholder: 'My Custom Size',
      width: 'Width (pixels)',
      height: 'Height (pixels)',
      cancel: 'Cancel',
      create: 'Create',
    },
    size_categories: {
      social: 'Social Media',
      device: 'Device',
      print: 'Print',
      aspect: 'Aspect Ratios',
      custom: 'Custom Size',
      add_custom: 'Add Custom Size',
    },
    credits: 'Credits',
    guide: 'Get More Credits',
    projectType: {
      title: 'Change Project Visibility',
      public: {
        label: 'Public',
        description: 'Anyone can view and remix',
        tips: 'Anyone can remix this project. This means it can be copied and edited based on it. To disable remixing, upgrade and switch to private.',
      },
      private: {
        label: 'Private',
        description: 'Only visible to you unless shared',
        tag: 'Pro',
      },
      upgrade: 'Upgrade to Pro',
    },
    mobileWarning: {
      title: 'Mobile Devices Not Supported',
      message: 'Please use desktop browser',
      button: 'Got It',
    },
    optimizePrompt: {
      title: 'Smart Prompt Optimization',
      action: 'Smart Prompt Optimization (for prompts less than 60 characters)',
      aiCommunication: 'Optimize your design prompt with Seede AI for more precise results',
      aiCommunicationShort: 'AI Design Communication',
      optimize: 'Optimize',
      description:
        'Your prompt seems a bit short. Would you like to use our optimized version for better results?',
      original: 'Original Prompt:',
      optimized: 'Optimized Prompt:',
      optimizing: 'Optimizing prompt...',
      originalDesc: 'The original input prompt that will be used as the optimization base.',
      optimizedDesc: 'You can edit the AI-generated optimized prompt',
      useOriginal: 'Use Original',
      useOptimized: 'Use Optimized',
    },
    optimizationChat: {
      generateNow: 'Generate Now',
      title: 'AI Design Requirements Optimization',
      description: "Let's refine your design requirements for the best results",
      startPrompt: 'What specific design elements or style do you need?',
      customInputPlaceholder:
        "If you're not satisfied with the existing options, you can also enter your requirements here...",
      thinking: 'Processing...',
      optimizedPromptLabel: 'Optimized Prompt:',
      submitCustom: 'Submit',
      continueOptimizing: 'Continue Optimizing',
      clickToContinue: 'Click the options below to continue optimizing',
      retry: 'Retry',
      errorGenerating: 'Content Generation Error',
      errorMessage: 'Content generation failed. Please try again.',
      finalPromptError: 'Final prompt generation failed.',
      conversationError: 'Unable to continue conversation.',
      nextQuestionError: 'Unable to generate next question.',
      optimizeError: 'Unable to start optimization conversation.',
      useOptimized: 'Use Optimized Prompt',
      finalPromptSuccess: 'Your design prompt has been optimized!',
      maxStepsReached: 'Maximum conversation steps reached',
      designRequirements: 'Design Requirements',
      visualStyle: 'Visual Style',
      layoutPreferences: 'Layout Preferences',
      colorScheme: 'Color Scheme',
      typographyChoices: 'Typography Choices',
      additionalNotes: 'Additional Notes',
    },
    insufficientCredits: {
      title: 'Insufficient Credits',
      description: 'You have used all your credits. Invite friends to get more credits!',
    },
    generateMode: {
      title: 'Generation Mode',
      fast: 'Fast Mode',
      workflow: 'Advanced Mode',
      fastDescription: 'Single Agent mode, fast generation speed',
      workflowDescription:
        'Multi-Agent generation mode, fast generation speed with higher design quality',
    },
    batch: {
      design: 'design',
      designs: 'designs',
      generateOne: 'Generate 1 design',
      generateMultiple: 'Generate {{count}} designs',
      title: 'Batch Generation',
      description:
        'Generate multiple design variations at once to explore different creative directions.',
      hint: 'More designs = More creative choices',
      single: 'Generate 1 design at a time',
      double: 'Generate 2 designs at once',
      quad: 'Generate 4 designs at once',
      nine: 'Generate 9 designs at once',
      singleImage: 'Single',
      multipleImages: 'Images',
    },
    inputRequiredTitle: 'Input Required',
    promptTemplateHint:
      'Click on the prompt templates above to get started quickly, or enter your own creative ideas',
    promptTemplates: 'Prompt Templates',
    recentProjects: 'My Projects',
    latestTemplates: 'Latest Templates',
    featuredProjects: 'Featured Designs',
    communityFavorites: 'Community Favorites and Trending Designs',
    loadingFeatured: 'Loading featured projects...',
    continueWork: 'Continue from where you left off',
    featured: 'featured designs',
    readyToUse: 'Scroll down to see more prompt examples, click to use creative prompts',
    viewAll: 'View All',
    viewMore: 'View More',
    items: 'items',
    view: 'View',
    open: 'Open',
    noRecentProjects: 'No recent projects found',
    firstDesign: 'Create your first design by selecting a template or using Seede AI',
    noTemplates: 'No templates available',
    noFeaturedProjects: 'No featured design here.',
    checkBackLater: 'Featured design from the community.',
    colorSchemes: {
      defalt: 'Default Color Scheme',
      monochrome: 'Monochrome',
      business: 'Business Professional',
      cafe: 'Cafe',
      restaurant: 'Restaurant',
      vintage: 'Vintage',
      modern: 'Modern Corporate',
      nature: 'Nature',
      luxury: 'Luxury',
      tech: 'Tech',
      pastel: 'Pastel',
      retro: 'Retro',
      custom: 'Custom Colors',
    },
  },
  imageGenerator: {
    title: 'AI Image Generator',
    subtitle: 'Transform Text into Stunning Images in Seconds',
    prompt: {
      label: 'Prompt',
      placeholder: 'Describe the image you want to generate...',
      enhance: 'Enhance Prompt',
      enhancing: 'Enhancing...',
      getInspiration: 'Get Inspiration',
      clear: 'Clear',
    },
    history: 'History',
    historyDialog: {
      title: 'History',
      description: 'View your previous image generations.',
    },
    generate: 'Generate',
    stylePreset: 'Style Preset',
    moreOptions: 'More Options',
    createFirst: {
      title: 'Create Your First Image',
      description:
        'Transform your ideas into stunning visuals. Simply describe what you want to create and let AI do the magic.',
      tryExample: 'Try an example prompt →',
      outputSize: 'Output Size:',
    },
    errors: {
      missingPrompt: {
        title: 'Missing Prompt',
        description: 'A prompt is required to generate an image.',
      },
      generic: {
        title: 'Uh oh! Something went wrong.',
      },
    },
  },
  useCases: {
    title: 'Use Cases',
    description:
      'Explore how Seede AI can transform your creative workflow with these powerful use cases',
    seoTitle: 'AI Design Use Cases | Seede AI',
    seoDescription:
      'Discover how Seede AI can help you create stunning designs for social media, posters, newsletters, and more with our AI-powered design tools.',
    seoKeywords:
      'AI design, design use cases, social media posts, posters, newsletters, podcast covers, flash cards, video thumbnails',
    learnMore: 'Learn More',
    tryNow: 'Try now',
    socialMedia: {
      title: 'Social Media Posts',
      description: 'Create engaging social media content with Seede AI',
    },
    minimalistPoster: {
      title: 'Minimalist Posters',
      description: 'Design clean and modern minimalist posters with professional layouts',
    },
    letterCard: {
      title: 'Letter Cards',
      description: 'Create beautiful letter-style cards with elegant typography and layouts',
    },
    podcastCover: {
      title: 'Podcast Covers',
      description: 'Design eye-catching podcast cover art with Apple-inspired aesthetics',
    },
    videoCover: {
      title: 'Video Covers',
      description: 'Create professional video thumbnails with Notion-style minimalism',
    },
    flashCard: {
      title: 'Flash Cards',
      description: 'Design effective vocabulary and study flash cards with clear layouts',
    },
    newsletter: {
      title: 'Newsletters',
      description: 'Create professional newsletter designs with clean typography and imagery',
    },
  },
  batchMode: {
    title: 'Batch Project Preview',
    description:
      'Your batch creations are ready! Review and select the designs that best match your vision. Click on any project to explore and refine it further.',
    startAnotherBatch: 'Start Another Batch',
    foundPerfectDesign: 'Found your perfect design?',
    emptyStateTitle: 'No Batch Designs Yet',
    emptyStateDescription:
      'Create multiple design variations at once by starting a batch generation from the create page.',
    startCreating: 'Start Creating',
    regenerate: 'Regenerate',
    yourPrompt: 'Your Prompt',
    generationFailed: 'Generation failed',
    edit: 'Edit',
    status: {
      pending: 'Pending',
      generating: 'Generating',
      completed: 'Completed',
      error: 'Error',
    },
  },
  designError: {
    title: 'Unable to Access Design',
    messages: {
      Forbidden:
        "You don't have permission to view this project. It may be private or has been deleted.",
      NetworkError:
        'Network error occurred while trying to fetch the resource. Please check your internet connection and try again.',
      NotFound: 'The requested resource could not be found. Please check the URL and try again.',
      Unauthorized:
        "You don't have permission to access this resource. Please login or contact support.",
      ServerError: 'The server encountered an error. Please try again later or contact support.',
    },
    errorDetails: 'Error Details',
    returnHome: 'Return to Home',
    errorIcon: 'Error Icon',
  },
  preview: {
    title: 'Preview',
    share: 'Share',
    description: 'Preview and edit your designs',
    back: 'Back to Create',
    export: 'Export',
    createNew: 'Create New',
    readonly: 'Read only',
    chat: 'Chat',
    edit: 'Edit',
    layers: 'Layers',
    images: 'Image',
    text: 'Text',
    library: 'Library',
    dragToCanvas: 'Drag to canvas',
    send: 'Send',
    sending: 'Sending...',
    sendShortcut: 'Shift + Enter to send',
    credits: 'Credits',
    typeMessage: 'Type your message...',
    tokensGenerated: '{{count}} tokens generated',
    generationComplete: '✅ Design generation complete!',
    savingMasterpiece: '💾 Saving your masterpiece...',
    generationError: '🔄 Oops! Something went wrong. Let me try again...',
    generationStopped: '⏹️ Generation stopped',
    stopGeneration: 'Stop Generation',
    somethingWrong: 'Sorry, something went wrong. Please try again.',
    imageEditSuccess: 'Image edited successfully! Your design has been updated.',
    textEditSuccess: 'Text edited successfully! Your design has been updated.',
    timeoutError:
      'Timeout waiting for design to render. This usually happens when the generated code has syntax errors.',
    seedeRootError:
      "The design couldn't be rendered properly. This might be due to complex elements or browser limitations.",
    tryAgainSimpler: 'Please try again with a simpler design request or refresh the page.',
    needMoreCredits: 'You need more credits to continue',
    getMoreCredits: 'Buy Credits',
    inviteForCredits: 'Get free Credits',
    upgradeAccount: 'Upgrade your account for unlimited access',
    creditsExhausted: 'Your credits have been exhausted',
    freeCreditsAvailable: 'Get 5 free credits by inviting a friend',
    limitReached: 'You have reached your usage limit',
    continueWithCredits: 'Add credits to continue creating amazing designs',
    generationCompleted: 'Generation completed',
    designingPoster: '🎨 Seede AI is designing your poster...',
    copy: 'Copy',
    error: 'Error',
    regenerate: 'Regenerate',
    task: {
      analysis: 'Requirement Analysis',
      typography: 'Typography',
      style: 'Design Style',
      layout: 'Page Layout',
      code: 'Design Building',
      build: 'Design Synthesis',
      image: 'Image Processing',
    },
    snapshot: {
      title: 'Project Snapshot',
      description: 'Project version snapshot',
      noPreviewAvailable: 'No preview available',
      restoreSnapshot: 'Restore This Version',
      viewSnapshot: 'View Snapshot',
      snapshotDescription: 'Project version snapshot',
      restoreConfirm: 'Are you sure you want to restore this version?',
      restoreSuccess: 'Version restored successfully',
      restoreFailed: 'Failed to restore design version.',
      created: 'Snapshot created',
      loading: 'Loading snapshot...',
    },
    chatMessage: {
      copyToClipboard: 'Copy to clipboard',
      copySuccess: 'Copied to clipboard',
      copySuccessDescription: 'Text has been copied successfully',
      copyFailed: 'Copy failed',
      copyFailedDescription: 'Unable to copy text to clipboard',
    },
  },
  exportMenu: {
    title: 'Export Settings',
    description: 'Choose format and quality for export',
    exportImage: 'Export',
    copyToClipboard: 'Copy to Clipboard',
    copying: 'Copying...',
    selectPage: 'Select Page',
    choosePage: 'Choose page to export',
    fileFormat: 'File Format',
    fileName: 'File Name',
    page: 'Page',
    selectPageError: 'Please select at least one page to export',
    exportAll: 'Export All',
    exportAllPages: 'Export all pages at once',
    selectFormat: 'Select format',
    pngFormat: 'PNG (High Quality)',
    jpgFormat: 'JPG (Compressed)',
    webpFormat: 'WebP (Modern Format)',
    pdfFormat: 'PDF (Document Format)',
    mp4Format: 'MP4 (Video)',
    pptFormat: 'PPT (Alpha)',
    htmlFormat: 'HTML',
    fps: 'FPS',
    duration: 'Duration',
    resolution: 'Resolution',
    selectResolution: 'Select resolution',
    standard: 'Standard (1x)',
    highRes: 'High Resolution (2x)',
    ultraHighRes: 'Ultra High Resolution (3x)',
    extremeHighRes: 'Extreme High Resolution ({{value}}x)',
    printOptimized: 'Print Optimized',
    dpi: 'DPI (Dots Per Inch)',
    selectDpi: 'Select DPI',
    cmykColorSpace: 'CMYK Color Space',
    cmykDescription: 'Optimized for professional printing',
    copiedToClipboard: 'Copied to Clipboard',
    copySuccess: 'Image has been successfully copied to clipboard',
    copiedAs: 'Copied as {{format}}',
    exporting: 'Exporting...',
    preparingDownload: 'Preparing your download...',
    downloadComplete: 'Your download is ready',
    downloadFailed: 'Download failed. Please try again.',
    success: 'Success',
    copyFailed: 'Copy failed. Please try again.',
    printSize: 'Print Size (cm)',
    customSize: 'Custom Size (cm)',
    quickPresets: 'Quick Presets',
    error: 'Error',
    cmykMode: 'CMYK Color Space',
    printOptimizedDescription: 'Optimize for professional printing',
    multiplePages: 'Multiple Pages',
    allPages: 'All Pages',
    currentPage: 'Current Page',
    downloadStarted: 'Download started',
    processingFiles: 'Processing files...',
    selectedPages: '{{count}} pages selected',
    viewingDistance: {
      veryFar: 'For billboards and very large formats (10+ m)',
      far: 'For viewing from a distance (3-10 m)',
      medium: 'For normal viewing distance (1-3 m)',
      close: 'For close inspection (0.3-1 m)',
      detailed: 'For detailed professional printing (< 0.3 m)',
    },
    sizeTable: {
      title: 'Standard Paper Size Reference Table',
      format: 'Format',
      width: 'Width',
      height: 'Height',
      dimensions: 'cm',
      clickToApply: 'Click to apply this size',
      customSize: 'Custom Size',
    },
    copyNotSupported: 'Copy Not Supported',
    copyNotSupportedDesc: "Your browser doesn't support copying images to clipboard",
    bleedSize: 'Bleed Size (mm)',
    bleedSizeDescription: 'Extra area for trimming (recommended: 3mm)',
    badgeStyle: 'Badge Style',
    selectBadgeStyle: 'Select badge style',
    hideBadge: 'Hide badge',
    badgeProOnly: 'Pro users can choose to hide the footer badge',
  },
  signIn: {
    title: 'Sign in',
    createYourAccount: 'Create your account',
    signUp: 'Sign up',
    signIn: 'Sign in',
    welcomeBack: 'Welcome back!',
    joinToday: 'Join Seede.ai today',
    googleUnavailable: 'Google Sign-in Unavailable',
    useEmailInstead: 'Please use email sign-in instead.',
    accessTools: 'Create stunning visuals in minutes. No design skills needed.',
    email: 'Email',
    emailPlaceholder: 'Enter your email',
    inputPlaceholder: 'Please enter',
    continueWith: 'Continue with',
    continueWithEmail: 'Continue with Email',
    continueWithPhone: 'Continue with Phone',
    phone: 'Phone',
    phonePlaceholder: 'Enter your phone number',
    smsCode: 'Code',
    emailCode: 'Code',
    smsCodePlaceholder: 'Enter 6-digit code',
    sendCode: 'Send Code',
    resendCode: 'Resend',
    smsCodeSent: 'SMS code sent successfully',
    smsCodeRequired: 'Please enter SMS code',
    phoneRequired: 'Please enter phone number',
    password: 'Password',
    passwordPlaceholder: 'Enter your password',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Confirm your password',
    inviteCode: 'Invite Code (Optional)',
    haveInviteCode: 'Have an invite code?',
    inviteCodePlaceholder: 'Enter your invite code',
    loginButton: 'Sign in',
    registerButton: 'Sign up',
    noAccount: "Don't have an account? Sign up",
    hasAccount: 'Already have an account? Sign in',
    loginFailed: 'Login failed. Please check your email and password and try again.',
    networkError: 'Network error',
    orContinueWith: 'Or continue with',
    passwordMismatch: 'Passwords do not match',
    agreeToTerms: 'By clicking "Continue with Google" or sign up, you agree with our',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    and: 'and',
    forgotPassword: 'Forgot your password?',
    agreeToTermsRequired: 'Please accept our Terms of Service and Privacy Policy to continue',
    emailRequired: 'Please enter your email address',
    invalidEmail: 'Please enter a valid email address',
    emailCodeSent: 'Email verification code sent successfully',
    emailMessages: {
      6001: 'Email is required',
      6002: 'Invalid email format',
      6003: 'Email already exists',
      6004: 'Temporary email addresses are not allowed',
      6005: 'Failed to send verification email',
    },
    messages: {
      6001: 'email already exists',
      6002: 'invalid email、phone number or password',
      6003: 'password is too short',
      6004: 'invalid email',
      6005: 'Temporary email addresses are not allowed',
    },
    smsMessages: {
      6001: 'Phone number is required',
      6002: 'Invalid phone number format',
      6003: 'Phone number is already registered',
      6004: 'Failed to send SMS verification code',
      6005: 'Internal server error',
    },
  },
  forgotPassword: {
    seoTitle: 'Reset Password - Seede AI',
    seoDescription:
      'Reset your Seede.ai account password securely. Enter your email to receive a verification code and create a new password.',
    seoKeywords: 'reset password,forgot password,password recovery,seede ai,account recovery',
    title: 'Forgot Password?',
    description:
      "Enter your email address and we'll send you a verification code to reset your password.",
    resetTitle: 'Reset Your Password',
    resetDescription:
      "We've sent a verification code to {{email}}. Enter the code below along with your new password.",
    verificationCode: 'Verification Code',
    codePlaceholder: 'Enter the 6-digit code',
    newPassword: 'New Password',
    newPasswordPlaceholder: 'Enter your new password (min 6 characters)',
    sendCode: 'Send Verification Code',
    sending: 'Sending...',
    resetButton: 'Reset Password',
    resetting: 'Resetting...',
    backToSignIn: '← Back to Sign In',
    backToEmail: '← Back to Email',
    successTitle: 'Password Reset Successfully!',
    successDescription:
      'Your password has been reset successfully. You can now sign in with your new password.',
    signInNow: 'Sign In Now',
    sideTitle: 'Secure Password Recovery',
    sideDescription:
      'Reset your password securely and get back to creating amazing designs with Seede.ai',
    emailRequired: 'Please enter your email address',
    invalidEmail: 'Please enter a valid email address',
    sendCodeFailed: 'Failed to send verification code. Please try again.',
    codeRequired: 'Please enter the verification code',
    passwordRequired: 'Please enter a new password',
    passwordTooShort: 'Password must be at least 6 characters long',
    passwordMismatch: 'Passwords do not match',
    resetFailed: 'Failed to reset password. Please try again.',
  },
  designHeaderMenu: {
    back: 'Back',
    view: 'View',
    layout: 'Layout',
    zoom: 'Zoom',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    zoomToFit: 'Zoom to fit',
    shortcuts: 'Keyboard shortcuts',
    help: 'Help',
    docs: 'Docs',
    support: 'Support',
    untitled: 'Untitled',
    readonly: 'Read only',
    export: 'Export',
    project: 'Project',
    makePublic: 'Make Public',
    makePrivate: 'Make Private',
    visibility: 'Visibility',
    public: 'Public - Anyone with the link can view',
    private: 'Private - Only you can view',
    visibilitySuccess: 'Project visibility updated',
    visibilitySuccessDesc: 'Your project is now {{visibility}}',
    visibilityFailed: 'Failed to change visibility',
    visibilityFailedDesc:
      'There was an error changing your project visibility. Please try again later.',
    save: 'Save',
    saving: 'Saving...',
    savingDesc: 'Your project is being saved.',
    saveSuccess: 'Project Saved',
    saveSuccessDesc: 'Your project has been saved successfully.',
    edit: 'Edit',
    undo: 'Undo',
    redo: 'Redo',
    cut: 'Cut',
    copy: 'Copy',
    paste: 'Paste',
    duplicate: 'Duplicate',
    delete: 'Delete',
    selectAll: 'Select All',
    copyStyle: 'Copy Style',
    pasteStyle: 'Paste Style',
    saveFailed: 'Save Failed',
    saveFailedDesc: 'Failed to save your project. Please try again.',
    horizontalLayout: 'Horizontal',
    verticalLayout: 'Vertical',
  },
  templates: {
    title: 'Templates',
    description: 'Explore our collection of professionally designed templates',
    loading: 'Loading templates...',
    filter: 'Filter by tag',
    allTags: 'All tags',
    noTemplates: 'No templates found',
    createFromTemplate: 'Create from template',
    backToAllTemplates: 'Back to All Templates',
    allTemplates: 'All Templates',
    categories: 'Categories',
    viewAll: 'View All',
    browseByCategory: 'Browse By Category',
    recentlyUpdated: 'Recently Updated',
  },
  templateDetail: {
    title: 'Template Details',
    backToTemplates: 'Back to Templates',
    useTemplate: 'Use This Template',
    loading: 'Loading template...',
    description: 'Description',
    tags: 'Tags',
    copyPrompt: 'Copy Prompt',
    remix: 'Remix',
    creating: 'Creating...',
    relatedTemplates: 'Related Templates',
    templateInfo: 'Template Information',
    dimensions: 'Dimensions',
    category: 'Category',
    createdBy: 'Created By',
    dateCreated: 'Date Created',
    lastModified: 'Last Modified',
    templateStats: 'Template Stats',
    usageCount: 'Usage Count',
    favoriteCount: 'Favorite Count',
    shareTemplate: 'Share Template',
    downloadTemplate: 'Download Template',
    similarTemplates: 'Similar Templates',
    editTemplate: 'Edit Template',
    previewTemplate: 'Preview Template',
    templateVersion: 'Version',
    templateSize: 'File Size',
    templateFormat: 'Format',
    prompt: 'Prompt',
    promptCopied: 'Prompt copied to clipboard!',
    copyPromptError: 'Failed to copy prompt',
    editContent: 'Edit Content',
    contentSpecifications: 'Content Specifications',
    model: 'Model',
    universal: 'Universal',
    version: 'Version',
    created: 'Created',
    updated: 'Updated',
    content: 'Content',
    moreElements: '+ {{count}} more elements',
    useOriginalPrompt: 'Use Original Prompt',
    chooseImage: 'Choose image',
    variable: 'Variable {{index}}',
    enterText: 'Enter text',
    copyToClipboard: 'Copy to clipboard',
  },
  templatesTag: {
    title: 'Templates by Tag',
    description: 'Explore templates filtered by specific tags',
    noTemplatesFound: 'No templates found with this tag',
    loading: 'Loading tagged templates...',
    viewAllTemplates: 'View All Templates',
    taggedWith: 'Templates tagged with {{tag}}',
  },
  help: {
    title: 'Help Center',
    faqTitle: 'Frequently Asked Questions',
    faqs: [
      {
        question: 'How to get started with Seede.ai?',
        answer:
          'You can start using Seede.ai by registering an account and logging in. We provide an easy-to-use interface and tutorials to help you get started quickly.',
      },
      {
        question: 'What file formats does Seede.ai support?',
        answer: 'We support common image formats such as JPG, PNG, SVG, and Webp.',
      },
      {
        question: 'How to upgrade to the Pro version?',
        answer:
          'You can find the upgrade option in your account settings and choose a subscription plan that suits you.',
      },
      {
        question: 'How to get technical support?',
        answer:
          'You can check our help documentation or contact our technical support team at hi@seede.ai.',
      },
      {
        question: 'How to export my designs?',
        answer:
          'After editing, click the export button in the top right corner and select your desired format（PNG/PDF/JPG） and resolution to download.',
      },
      {
        question: 'Can I collaborate with team members on Seede.ai?',
        answer:
          "Currently, Seede.ai doesn't support collaboration features. We're working on adding team collaboration functionality in a future update.",
      },
      {
        question: 'Is there a mobile app for Seede.ai?',
        answer: 'Currently, Seede.ai is optimized for desktop use.',
      },
      {
        question: 'Can I use Seede.ai for commercial projects?',
        answer:
          'Absolutely! Seede.ai can be used for both personal and commercial projects. Our Pro version offers additional features for professional use.',
      },
      {
        question: 'Do you offer custom templates for specific industries?',
        answer:
          'Yes, we provide a wide range of templates categorized by industry and use case. You can also request custom templates through our support channel.',
      },
      {
        question: 'How often are new features added to Seede.ai?',
        answer:
          'We regularly update Seede.ai with new features and improvements. We release major updates quarterly and smaller enhancements monthly.',
      },
      {
        question: 'Can I cancel my subscription at any time?',
        answer:
          'Yes, you can cancel your subscription at any time from your account settings. Your access will continue until the end of your billing period.',
      },
    ],
    contactTitle: 'Need more help?',
    contactDescription:
      "If the FAQs don't solve your problem, please contact us through the following methods:",
    contactEmail: 'Email: hi@seede.ai',
    workingHours: 'Working hours: Monday to Friday 9:00 - 18:00',
  },
  notFound: {
    title: 'Page Not Found',
    description: "The page you're looking for doesn't exist or has been moved.",
    goHome: 'Go Back Home',
  },
  contact: {
    title: 'Contact Us',
    getInTouch: 'Get in Touch',
    contactDescription: 'For any inquiries or support, please contact us at:',
    contactInfo: 'Contact Info',
    email: 'Email: hi@seede.ai',
    socialMedia: 'Social Media',
    followUs: 'Follow us for updates',
    twitterHandle: '@seedeAI',
    support: 'Support',
    supportDescription: 'Need help with our products?',
    business: 'Business',
    businessDescription: 'For partnerships & opportunities',
    contactEmail: 'hi@seede.ai',
  },
  tools: {
    title: 'Tools',
    mainProduct: '🎨 Seede AI',
    mainProductDesc: 'AI-powered design tool for social media and marketing',
    text2image: '✨ Text to Image',
    text2imageDesc: 'Generate images from text descriptions',
    video: '🎥 Landscape to Portrait Video Tool',
    videoDesc: 'Convert landscape videos to portrait format for social media',
    imageProcessing: '🖼️ Image Processing',
    imageProcessingDesc: 'Edit and enhance your images',
    imageGeneration: '🎨 Image Generation',
    imageGenerationDesc: 'Create AI-generated images',
    imageUpscaling: '⚡ Image Upscaling',
    imageUpscalingDesc: 'Enhance image resolution and quality',
    backgroundRemoval: '✂️ Background Removal',
    backgroundRemovalDesc: 'Remove image backgrounds automatically',
    magicEraser: '🪄 Magic Eraser',
    magicEraserDesc: 'Remove unwanted objects from images',
    playground: '🧩 Code to Canvas Playground',
    playgroundDesc: 'Convert HTML/React/SVG to canvas and experiment with designs',
    playgroundTitle: 'Code to Canvas Playground',
    playgroundSubtitle: 'Experiment with HTML/React/SVG and see it rendered on canvas',
    playgroundFeatures: 'Interactive design environment with real-time preview',
    playgroundUsage: 'Great for prototyping and testing design ideas',
  },
  videoTool: {
    title: '🎥 Landscape to Portrait Video Tool',
    description: 'Convert landscape videos to portrait format for social media',
    uploadVideo: 'Upload Video',
    uploadVideoDesc: 'Supports common formats like MP4, WebM',
    uploadBackground: 'Upload Background Image',
    uploadBackgroundDesc: 'Supports JPG, PNG and other common formats',
    clickToUploadVideo: 'Click to upload video',
    clickToUploadBackground: 'Click to upload background image',
    bitrate: 'Bitrate',
    encoder: 'Encoder',
    processing: 'Processing...',
    processProgress: 'Processing Progress',
    timeElapsed: 'Time Elapsed: {{time}}s',
    startMerge: 'Start',
    errorMessages: {
      uploadRequired: 'Please upload video and background image',
      resolutionTooHigh:
        'Video resolution is too high, please use lower resolution video or select higher encoding level',
      processFailed: 'Video processing failed, please try again',
    },
  },
  invite: {
    title: 'Invite Friends',
    guide: 'Get More Credits',
    credits: 'Credits',
    succeededDescription: 'Successfully verified, 5 credits awarded',
    pending: 'Pending',
    pendingDescription: 'Waiting for email verification',
    subtitle: 'Get 5 credits for both you and your friend!',
    description:
      'When your friends register and verify their account using your invite link, you both will receive 5 credits.',
    inviteLink: 'Invitation Link',
    copyLink: 'Copy Link',
    copySuccess: 'Copied',
    copyDescription: 'Invitation link has been copied to clipboard',
    records: 'Invitation Records',
    recordCount: 'Total {{count}} records',
    noRecords: 'No invitation records',
    noRecordsDesc: 'Share your invitation link to see records',
    user: 'User',
    registered: 'Registered',
    usage: 'Usage',
    usageDescription: 'Used',
  },
  profile: {
    title: 'My Profile',
    usage: 'Usage',
    usageDescription: 'Credits Used',
    buyCredits: 'Get Credits Now',
    inviteFriends: 'Invite & Earn Credits',
    recentProjects: 'Recent Projects',
    viewAll: 'View All',
    createNew: 'Create New Project',
    sendVerification: 'Send Email verification',
    editProfile: 'Edit Profile',
    changeAvatar: 'Change Avatar',
    displayName: 'Display Name',
    bio: 'Bio',
    bioPlaceholder: 'Tell us about yourself',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    cancel: 'Cancel',
    profileUpdated: 'Profile updated successfully',
    updateFailed: 'Failed to update profile',
    characterLimit: '{{current}}/{{max}} characters',
    avatarUploadFailed: 'Failed to upload avatar',
    avatarUploadSuccess: 'Avatar uploaded successfully',
    loadMore: 'Load More Projects',
    notFound: 'User Not Found',
    notFoundDesc: 'The user profile you are looking for does not exist or may have been removed.',
    backHome: 'Back to Home',
    noProjects: 'No Public Projects Yet',
    noProjectsDesc: 'This user has not published any public projects yet. Check back later!',
  },
  success: {
    title: 'Payment Successful!',
    description: 'Your payment has been processed successfully. Thank you for your purchase.',
    dashboard: 'Go to Dashboard',
    createNew: 'Create New Design',
  },
  dashboard: {
    RecentDesigns: 'Recent Designs',
    ShowAll: 'Show All',
    ShowStarred: 'Show Starred',
    NewDesign: 'New design',
    CreateNewProject: 'Create New Project',
    LoadingProjects: 'Loading projects...',
    WelcomeTitle: 'Welcome to Seede',
    WelcomeDescription:
      'Click the button below to add a new design project and start your creative journey.',
    NoProjects: 'No projects yet',
    StarredProjects: 'Starred Projects',
  },
  project: {
    open: 'Open',
    duplicate: 'Duplicate',
    delete: 'Delete',
    star: 'Star',
    unstar: 'Unstar',
    rename: 'Rename',
    lastEdited: 'Last edited',
    untitled: 'Untitled Project',
    confirmDelete: 'Are you sure you want to delete this project?',
    deleteSuccess: 'Project deleted successfully',
    duplicateSuccess: 'Project duplicated successfully',
  },
  auth: {
    emailVerificationRequired: 'Email Verification Required',
    verificationDescription: "Please verify your email address. We've sent a verification link to:",
    resendVerificationEmail: 'Resend Verification Email',
    sending: 'Sending...',
    verificationEmailSent: 'Verification email sent successfully!',
    checkInbox: 'Please check your inbox and spam folder for the verification email.',
    verificationEmailFailed: 'Failed to send verification email',
    tryAgainLater: 'Please try again later or contact support if the problem persists.',
    enterCode: 'Enter Code',
    cancel: 'Cancel',
    verify: 'Verify',
    verifying: 'Verifying...',
    verificationSuccess: 'Verification Successful!',
    emailVerified: 'Your email has been successfully verified.',
    verificationFailed: 'Verification Failed',
    invalidCode: 'Invalid verification code. Please try again.',
    close: 'Close',
    login: 'Login',
    signup: 'Sign Up',
    forgotPassword: 'Forgot Password?',
    resetPassword: 'Reset Password',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    name: 'Name',
    loginSuccess: 'Login successful!',
    signupSuccess: 'Sign up successful!',
    passwordResetSuccess: 'Password reset successful!',
    passwordResetRequest: 'Password reset link sent to your email',
    invalidCredentials: 'Invalid email or password',
    accountExists: 'Account already exists with this email',
    accountNotFound: 'No account found with this email',
    passwordMismatch: 'Passwords do not match',
    requiredField: 'This field is required',
  },
  posterStyles: {
    default: 'Style',
    service: 'Service Oriented',
    beauty: 'Beauty & Cosmetics',
    lifestyle: 'Lifestyle & Wellness',
    fashion: 'Fashion Forward',
    minimalist: 'Minimalist',
    lightshadow: 'Light & Shadow',
    gradient: 'Gradient Flow',
    vintage: 'Vintage Retro',
    geometric: 'Geometric Abstract',
    neon: 'Neon Glow',
    organic: 'Organic Nature',
    typographic: 'Typography Focus',
    isometric: 'Isometric 3D',
    glassmorphism: 'Glass Morphism',
    brutalism: 'Digital Brutalism',
  },
  resize: {
    title: 'Image Resize Tool',
    description: 'Resize your images to any dimension while maintaining quality',
    uploadImage: 'Upload Image',
    dropImage: 'Click to upload or drag and drop',
    supportedFormats: 'PNG, JPG, WEBP (MAX 10MB)',
    settings: 'Resize Settings',
    dimensions: 'Dimensions',
    width: 'Width',
    height: 'Height',
    maintainAspectRatio: 'Maintain aspect ratio',
    format: 'Format',
    quality: 'Quality',
    resize: 'Resize Image',
    processing: 'Processing...',
    reset: 'Reset',
    result: 'Result',
    download: 'Download Resized Image',
    noImageSelected: 'Please select an image first',
    processingError: 'Error processing image. Please try again.',
    imageLoadError: 'Error loading image. Please try a different file.',
  },
  border: {
    title: 'Image Border Tool',
    description:
      'Add a border to your pictures to make them stand out and win more likes on social media',
    uploadImage: 'Upload Image',
    livePreview: 'Live Preview',
    dropImage: 'Click to upload or drag and drop',
    supportedFormats: 'PNG, JPG, WEBP (MAX 10MB)',
    settings: 'Border Settings',
    width: 'Border Width',
    color: 'Border Color',
    style: 'Border Style',
    radius: 'Border Radius',
    format: 'Format',
    quality: 'Quality',
    apply: 'Apply Border',
    processing: 'Processing...',
    reset: 'Reset',
    result: 'Result',
    download: 'Download ',
    noImageSelected: 'Please select an image first',
    processingError: 'Error processing image',
    imageLoadError: 'Error loading image',
  },
  removeBg: {
    title: 'Background Removal Tool',
    description: 'Remove background from your images with one click using AI technology',
    uploadImage: 'Upload Image',
    dropImage: 'Click to upload or drag and drop',
    supportedFormats: 'PNG, JPG, WEBP (MAX 10MB)',
    settings: 'Output Settings',
    format: 'Format',
    quality: 'Quality',
    removeBackground: 'Remove Background',
    processing: 'Processing...',
    download: 'Download',
    reset: 'Reset',
    result: 'Result',
    preview: 'Preview',
    noImageSelected: 'Please select an image first',
    processingError: 'Error removing background from image',
    resultNote: 'Background has been removed. You can now download the image.',
    previewNote: "Click 'Remove Background' to process this image",
    rembg: 'Remove Background',
  },
  feedback: {
    title: 'How would you rate this AI-generated design?',
    thankYou: 'Thank you for your feedback!',
    goodQuality: 'Good',
    average: 'Average',
    poorQuality: 'Poor',
    submitSuccess: 'Feedback submitted successfully',
    submitError: 'Error submitting feedback. Please try again.',
    prompt: 'How would you rate this AI-generated design?',
    description: 'Your feedback helps us improve the AI design experience',
    poorQualityExplanation:
      'Poor generation quality may be due to unclear requirements or model limitations. Try adjusting your prompt or switching to a different model.',
    useAnotherModel: 'Use another model',
    tryDifferentModel: 'Explore alternative models for better results',
  },
  token: {
    title: 'API Tokens',
    description: 'Manage your API tokens for programmatic access',
    createNew: 'Create New Token',
    loading: 'Loading tokens...',
    noTokens: 'No API Tokens',
    noTokensDescription:
      "You haven't created any API tokens yet. Create one to access the API programmatically.",
    createFirst: 'Create Your First Token',
    name: 'Name',
    created: 'Created',
    key: 'Key',
    lastUsed: 'Last used',
    actions: 'Actions',
    delete: 'Delete',
    never: 'Never',
    securityNotice: 'Security Notice',
    securityDescription:
      'API tokens have full access to your account. Keep them secure and never share them publicly.',
    createToken: 'Create API Token',
    tokenName: 'Token Name',
    tokenNamePlaceholder: 'Enter a name for your token',
    tokenNameHelp: "Choose a descriptive name to identify this token's purpose",
    yourNewToken: 'Your New API Token',
    copyWarning: "Make sure to copy this token now. You won't be able to see it again!",
    done: 'Done',
    cancel: 'Cancel',
    create: 'Create Token',
    nameRequired: 'Token name is required',
    createError: 'Failed to create token',
    deleteSuccess: 'Token deleted successfully',
    deleteError: 'Failed to delete token',
    copySuccess: 'Token copied to clipboard',
    copyDescription: 'Keep this token secure',
    fetchError: 'Failed to load tokens',
  },
  inpaint: {
    title: 'Remove Objects',
    description: 'Paint over unwanted objects to remove them from your image',
    brushSize: 'Brush Size',
    brushSizeTooltip: 'Press [ and ] to quickly adjust brush size',
    history: 'History',
    clear: 'Clear',
    reset: 'Reset',
    saveChanges: 'Save changes',
    loading: 'Processing...',
    progress: 'Progress',
    zoom: 'Zoom',
    paintInstructions: 'Paint over the objects you want to remove',
    processingTime: 'Processing time: {{time}}s',
    noImageSelected: 'No image selected',
    exportSuccess: 'Image exported successfully',
    exportError: 'Failed to export image',
  },
  projectInfo: {
    page: 'Page',
    info: 'Project Info',
    save: 'Save',
    cancel: 'Cancel',
    name: 'Name',
    description: 'Description',
    namePlaceholder: 'Enter project name',
    descriptionPlaceholder: 'Enter project description',
    noDescription: 'No description',
    public: 'Public',
    private: 'Private',
    created: 'Created',
    updated: 'Updated',
  },
  redemption: {
    title: 'Redeem Your Code',
    subtitle: 'Enter your redemption code below to add credits to your account',
    seoTitle: 'Redeem Code - Seede AI',
    seoDescription: 'Redeem your code to get credits for AI design generation',
    codeLabel: 'Redemption Code',
    codePlaceholder: 'Enter your redemption code',
    redeemButton: 'Redeem',
    currentCredits: 'Current Credits',
    creditsDescription: 'Credits are used for AI design generation',
    helpTitle: 'How to use redemption codes?',
    help1: 'Enter your redemption code in the field above',
    help2: 'Click the "Redeem" button to add credits to your account',
    help3: 'Use your credits to generate amazing AI designs',
    emptyCode: 'Please enter a redemption code',
    success: 'Redemption Successful!',
    successDescription: 'Your benefits have been added to your account.',
    error: 'Redemption Failed',
    errorDescription: 'Invalid or expired redemption code.',
    alreadyRedeemed: 'You have already redeemed this code.',
    expiredOrLimit: 'This redemption code has expired or reached its usage limit.',
    invalidCode: 'Invalid or inactive redemption code.',
    credits: 'credits',
    type: {
      credits: 'Credits',
      subscription: 'Subscription',
      feature: 'Feature',
    },
  },
  themeSelector: {
    tooltip: 'Color Theme',
    default: 'Default',
    classicBlackWhite: 'Classic Black & White',
    oceanBlue: 'Ocean Blue',
    sunsetOrange: 'Sunset Orange',
    forestGreen: 'Forest Green',
    lavenderPurple: 'Lavender Purple',
    rosePink: 'Rose Pink',
    goldenLuxury: 'Golden Luxury',
    midnightBlue: 'Midnight Blue',
    defaultDescription: 'Default color scheme',
    classicBlackWhiteDescription: 'Classic black and white colors',
    oceanBlueDescription: 'Fresh ocean style',
    sunsetOrangeDescription: 'Warm sunset tones',
    forestGreenDescription: 'Natural forest colors',
    lavenderPurpleDescription: 'Elegant purple series',
    rosePinkDescription: 'Romantic pink tones',
    goldenLuxuryDescription: 'Premium golden colors',
    midnightBlueDescription: 'Deep night sky colors',
    emeraldLuxury: 'Emerald Luxury',
    emeraldLuxuryDescription: 'Luxurious emerald green tones',
    coralWarm: 'Coral Warm',
    coralWarmDescription: 'Vibrant coral warmth',
    indigoDeep: 'Indigo Deep',
    indigoDeepDescription: 'Deep indigo sophistication',
    amberWarm: 'Amber Warm',
    amberWarmDescription: 'Warm amber glow',
    tealFresh: 'Teal Fresh',
    tealFreshDescription: 'Fresh teal vibrancy',
    burgundyElegant: 'Burgundy Elegant',
    burgundyElegantDescription: 'Elegant burgundy richness',
    slateModern: 'Slate Modern',
    slateModernDescription: 'Modern slate sophistication',
    copperVintage: 'Copper Vintage',
    copperVintageDescription: 'Vintage copper warmth',
    turquoiseTropical: 'Turquoise Tropical',
    turquoiseTropicalDescription: 'Tropical turquoise freshness',
    plumRich: 'Plum Rich',
    plumRichDescription: 'Rich plum elegance',
    sageCalm: 'Sage Calm',
    sageCalmDescription: 'Calming sage serenity',
    charcoalSophisticated: 'Charcoal Sophisticated',
    charcoalSophisticatedDescription: 'Sophisticated charcoal depth',
    crimsonBold: 'Crimson Bold',
    crimsonBoldDescription: 'Bold crimson energy',
    navyProfessional: 'Navy Professional',
    navyProfessionalDescription: 'Professional navy confidence',
    mintFresh: 'Mint Fresh',
    mintFreshDescription: 'Fresh mint coolness',
    bronzeClassic: 'Bronze Classic',
    bronzeClassicDescription: 'Classic bronze elegance',
    steelIndustrial: 'Steel Industrial',
    steelIndustrialDescription: 'Industrial steel strength',
    ivoryElegant: 'Ivory Elegant',
    ivoryElegantDescription: 'Elegant ivory sophistication',
    mahoganyRich: 'Mahogany Rich',
    mahoganyRichDescription: 'Rich mahogany warmth',
    addCustomTheme: 'Add Custom Theme',
    hoverToPreview: 'Hover to preview colors',
    primaryColor: 'Primary Color',
    secondaryColor: 'Secondary Color',
    deleteCustomTheme: 'Delete Custom Theme',
    createCustomTheme: 'Create Custom Theme',
    createThemeDesc: 'Design your exclusive color scheme',
    themeName: 'Theme Name',
    themeDescription: 'Theme Description',
    themeNamePlaceholder: 'My Theme',
    themeDescriptionPlaceholder: 'Enter theme description',
    colorScheme: 'Color Scheme',
    smartColorExtraction: 'Smart Color Extraction',
    uploadImage: 'Upload image to extract colors',
    supportedFormats: 'Supports JPG, PNG formats, max 5MB',
    replaceImage: 'Replace',
    extractingColors: 'Extracting colors...',
    customColors: 'Custom Colors',
    primaryColorLabel: 'Primary Color',
    secondaryColorLabel: 'Secondary Color',
    color3Label: 'Background Color',
    color4Label: 'Border Color',
    preview: 'Preview',
    themePreview: 'Theme Preview',
    cancel: 'Cancel',
    saveTheme: 'Save Theme',
    copied: 'Copied!',
    pleaseSelectImage: 'Please select an image file',
    imageSizeLimit: 'Image size cannot exceed 5MB',
    colorExtractionFailed: 'Color extraction failed, please try again',
    imageLoadFailed: 'Image loading failed, please try again',
    imageProcessFailed: 'Image processing failed, please try again',
    cardExample: 'Card Example',
    cardExampleDesc: 'This is the card effect using your color scheme',
  },
  credits: {
    balance: 'Credit Balance',
    remaining: 'Remaining {{count}} credits',
    remainingCredits: 'Remaining credits',
    inviteFriends: 'Invite Friends',
    inviteReward: 'Get credits for each friend you invite to register',
    recharge: 'Recharge Credits',
    rechargeDesc: 'Purchase credit packages and enjoy more design features',
    rechargeNow: 'Buy Credits',
    exhausted: 'Credits exhausted. Please recharge to continue.',
  },
  attach: {
    addAttachment: 'Add Attachment',
    addReferenceImage: 'The design you want to reference',
    uploadImageMaterial: 'Materials needed for your design',
    uploading: 'Uploading...',
    supportedFormats: 'Supports PNG, JPG, JPEG, WEBP',
    selectMaterial: 'Select Material',
    failedToLoadAssets: 'Failed to load assets',
    material: 'Material',
    remove: 'Remove',
    asUsage: 'as {{usage}}',
    defaultUsage: 'Material',
    parsing: 'Parsing...',
    Category: {
      recommended: 'Recommended',
      businessMarketing: 'Business Marketing',
      creativeArt: 'Creative Art',
    },
    referenceImage: 'Reference',
    materialLibrary: 'Material',
    documents: 'Document',
    addDocuments: 'Upload document for one-click layout',
    supportedDocumentFormats: 'Supports DOCX, PDF, TXT, MD formats (max 15MB)',
    dragAndDropFiles: 'Drag and drop files here',
    or: 'or',
    browseFiles: 'Browse Files',
    uploadSuccessful: 'Upload successful',
    uploadFailed: 'Upload failed',
    fileTooBig: 'File size exceeds 10MB limit',
    unsupportedFormat: 'Unsupported file format',
    multipleFilesSupported: 'Multiple files supported',
    attachmentManager: 'Attachment Manager',
    noAttachments: 'No attachments',
    attachments: 'attachments',
  },
  material: {
    selectUsage: 'Select Usage',
    singleSelect: '(Single Select)',
    background: 'Background',
    product: 'Product',
    model: 'Model',
    logo: 'Logo',
    qrcode: 'QR Code',
    icon: 'Icon',
    decoration: 'Decoration',
    texture: 'Texture',
    chart: 'Chart',
    customUsagePlaceholder: 'Custom usage',
    add: 'Add',
  },
  attachTag: {
    editReferenceFeatures: 'Edit Reference Features',
    selectReferencePoints: 'Reference Points',
    multipleSelection: '(Multiple Selection)',
    referencePoints: {
      all: 'All',
      layout: 'Layout',
      style: 'Style',
      color: 'Color',
      texture: 'Texture',
      copy: 'Copy',
      font: 'Font',
    },
  },
  materialList: {
    viewMore: 'View more',
    selectUsage: 'Usage',
    selectedMaterials: 'Selected Materials',
    noSelectedMaterials: 'No materials selected',
    recentlyUploadedMaterials: 'Recently Uploaded Materials',
    failedToLoadAssets: 'Failed to load assets',
    noMaterials: 'No materials available',
    uploadMaterialsToUse: 'Upload materials to use them in your designs',
  },
  fillPanel: {
    color: 'Solid',
    solid: 'Solid',
    gradient: 'Gradient',
    dynamic: 'Dynamic Effects',
    image: 'Image',
    search: 'Search',
    uploadImage: 'Upload image',
    gradientDirection: 'Gradient Direction',
    documentColors: 'Document Colors',
  },
  iconLibrary: {
    iconLibrary: 'Icon Library',
    chooseFrom: 'Choose from',
    icons: 'icons',
    searchIcons: 'Search icons...',
    allIcons: 'All Icons',
    noIconsFound: 'No icons found',
    tryDifferentKeywords: 'Try different keywords or select another category',
    showAllIcons: 'Show All Icons',
    loadingIconSets: 'Loading icon sets...',
  },
  qrcodePanel: {
    colorPresets: 'Color Presets',
    qrCodeGenerator: 'QR Code Generator',
    createCustomQrCodes: 'Create custom QR codes for your designs',
    content: 'Content',
    enterUrlOrText: 'Enter URL or text...',
    styleSettings: 'Style Settings',
    margin: 'Margin',
    foreground: 'Foreground',
    background: 'Background',
    generating: 'Generating...',
    generateQrCode: 'Generate QR Code',
    addToDesign: 'Add to Design',
    createQrCode: 'Create QR Code',
    enterContentAndCustomize:
      'Enter your content and customize the style to generate a beautiful QR code',
  },
  assetUpload: {
    uploadImage: 'Upload Image',
    dragDropOrClick: 'Drag & drop your image here, or click to browse',
    chooseFile: 'Choose File',
    uploadingImage: 'Uploading image...',
    supportedFormats: 'JPG, PNG, WebP, SVG',
  },
  imagePanel: {
    imageTypes: 'Image Types',
    unsplash: 'Images',
    highQualityImages: 'High quality images',
    icon: 'Icons',
    beautifulIcons: 'Beautiful icons',
    qr: 'QR Code',
    generateQrCode: 'Generate QR code',
    generate: 'AI Generate',
    generateImage: 'Generate images with AI',
    selectImageType: 'Select image type',
    browse: 'Browse',
    search: 'Search',
    upload: 'Upload',
    illustration: 'Illustration',
    illustrationDesc: 'Beautiful illustrations for your designs',
  },
  quickQrCode: {
    editQrCode: 'Edit QR Code',
    qrCodeEditor: 'QR Code Editor',
    typeSelection: 'Type Selection',
    content: 'Content',
    generating: 'Generating...',
    generateQrCode: 'Generate QR Code',
    dragToAdd: 'Drag to add to canvas',
    advancedSettings: 'Advanced Settings',
    foregroundColor: 'Foreground Color',
    backgroundColor: 'Background Color',
    margin: 'Margin',
    size: 'Size',
    download: 'Download',
    preview: 'Preview',
    enterContentToGenerate: 'Enter content to generate QR code',
    selectImageFirst: 'Select an image first',
    types: {
      text: 'Text',
      url: 'Link',
      email: 'Email',
      phone: 'Phone',
      wifi: 'WiFi',
      contact: 'Contact',
    },
    placeholders: {
      text: 'Enter any text',
      url: 'https://example.com',
      email: 'user@example.com',
      phone: '+1 555 123 4567',
      wifi: 'WiFi Name;Password;Encryption Type',
      contact: 'Name;Phone;Email',
    },
    generateFailed: 'Failed to generate QR code',
    tips: {
      dragToCanvas: 'Drag the QR code to canvas to add it',
      selectImageNode: 'Select an image node to replace with QR code',
      adjustSettings: 'Adjust margin and colors to customize appearance',
    },
  },
  chatContent: {
    referenceImages: 'Reference Images',
    documents: 'Document',
    colorScheme: 'Color Scheme',
    materialFiles: 'Material Files',
    libraryItems: 'Library Items',
    designLibrary: 'Design Library',
    material: 'Material',
    style: 'Style',
  },
  modelSelector: {
    selectModel: 'Select Model',
    recommendedModels: 'Recommended Models',
    allModels: 'All Models',
    exploreMore: 'Explore More Models',
    additionalModels: 'More models available',
    otherModels: 'More Models',
    showLess: 'Show Less',
    mostPopular: 'Most Popular',
    multimodal: 'Supports Image Input',
    limitedTimeFree: 'Limited Time Free',
    new: 'New',
    promoDefault: 'Gemini 3 Pro Now Available',
    promoGemini: 'Yes, this is the one, just try it',
  },
  browserCompatibility: {
    error: {
      title: 'Browser Compatibility Error',
      description: "Your browser doesn't support required features.",
      checkDetails: 'Check compatibility details',
    },
    checkDetails: 'Check browser compatibility details',
  },
  textEffect: {
    title: 'Text Effects',
    description: 'Select preset styles',
    clearEffects: 'Clear Effects',
  },
  nodeTypes: {
    text: 'Text',
    image: 'Image',
    shape: 'Shape',
    line: 'Line',
    path: 'Path',
    col: 'Column',
    row: 'Row',
    group: 'Group',
    frame: 'Frame',
    video: 'Video',
  },
  shapeTypes: {
    rect: 'Rectangle',
    ellipse: 'Ellipse',
    triangle: 'Triangle',
    star: 'Star',
    polygon: 'Polygon',
    hexagon: 'Hexagon',
    octagon: 'Octagon',
    pentagon: 'Pentagon',
    cross: 'Cross',
    heart: 'Heart',
  },
  browser: {
    title: 'Browser Compatibility',
    description: "Check your browser's compatibility with Seede AI features",
    overallStatus: 'Overall Status',
    browserInfo: 'Browser Info',
    featureDetails: 'Feature Details',
    status: 'Status',
    retest: 'Retest',
    testing: 'Testing...',
    analyzing: 'Analyzing compatibility...',
    checkComplete: 'Compatibility Check Complete',
    checkCompleteDesc: 'Browser compatibility analysis finished successfully.',
    checkFailed: 'Check Failed',
    checkFailedDesc: 'Failed to run compatibility check.',
    recommendChrome: 'Recommended Browser: Chrome',
    recommendChromeDesc:
      'For the best Seede AI experience, we strongly recommend using the latest version of Google Chrome browser.',
    downloadChrome: 'Download Chrome',
    statuses: {
      fullyCompatible: 'Fully Compatible',
      compatibleWithWarnings: 'Compatible with Warnings',
      incompatible: 'Incompatible',
      unknown: 'Unknown',
      supported: 'Supported',
      notSupported: 'Not Supported',
    },
    categories: {
      required: 'Required',
      optional: 'Optional',
      compatible: 'Compatible',
      browser: 'Browser',
      version: 'Version',
      engine: 'Engine',
    },
    results: {
      pass: 'PASS',
      fail: 'FAIL',
      warn: 'WARN',
      yes: 'YES',
      no: 'NO',
    },
    issues: {
      criticalTitle: 'Critical Issues',
      criticalDesc: 'Update your browser for Seede AI compatibility.',
      performanceTitle: 'Performance Warnings',
      performanceDesc: 'Some features may have reduced performance.',
      excellentTitle: 'Excellent',
      excellentDesc: 'Full compatibility with all Seede AI features.',
    },
  },
  announcement: {
    title: 'Product Announcements',
    description:
      'Check the latest product updates, feature releases and important announcements from Seede AI',
    keywords: 'product announcements,update logs,feature releases,Seede AI',
    pageTitle: 'Product Announcements',
    pageDescription: 'Explore the latest features and product progress',
    loading: 'Loading...',
    noAnnouncements: 'No announcements',
    noAnnouncementsDesc: 'Awaiting new messages',
    subscribeTitle: 'Subscribe to Updates',
    subscribeDesc: 'Get important update notifications first',
    subscribeButton: 'Subscribe Now',
    error: 'Error',
    loadError: 'Failed to load announcements, please try again later.',
    types: {
      feature: 'Feature',
      improvement: 'Improvement',
      promotion: 'Promotion',
    },
    priorities: {
      high: 'High',
      medium: 'Medium',
      low: 'Low',
    },
    tags: {
      modelUpdate: 'Model Update',
      ai: 'AI',
      reasoningModel: 'Reasoning Model',
      newFeature: 'New Feature',
      uiOptimization: 'UI Optimization',
      userExperience: 'User Experience',
      performanceOptimization: 'Performance Optimization',
      systemUpgrade: 'System Upgrade',
      promotion: 'Promotion',
      discount: 'Discount',
    },
  },
  imageGeneratePanel: {
    title: 'AI Image Generation',
    subtitle: 'Create infinite possibilities with creative words',
    history: 'History',
    styleSection: 'Art Style',
    aiEnhanceTitle: 'AI Smart Enhancement',
    aiEnhanceDesc: 'Automatically translate and optimize your creative description',
    promptPlaceholder:
      'Describe the image in your mind, let AI present the beauty of art for you...',
    selectModel: 'Select Model',
    startCreate: 'Start Creating',
    resultTitle: 'Generation Result',
    creating: 'Creating...',
    createDone: 'Creation Complete',
    optimizingPrompt: 'Optimizing your creative description...',
    creatingImage: 'Carefully creating your image...',
    pleaseWait: 'Please wait, art is being born',
    selectArtwork: 'Select Artwork',
    generatedArtworkAlt: 'Generated artwork',
    generationFailed: 'Generation Failed',
    retry: 'Try Again',
    styleTitle: 'Style Selection',
    error: {
      generationFailedTitle: 'Generation Failed',
      generationFailed: 'Failed to generate image, please try again',
    },
    styles: {
      default: 'Default',
      defaultDesc: 'Natural style',
      cartoon: 'Cartoon',
      cartoonDesc: 'Cute cartoon style',
      photorealistic: 'Photorealistic',
      photorealisticDesc: 'Photorealistic style',
      render3d: '3D Render',
      render3dDesc: 'Exquisite 3D effects',
      oilPainting: 'Oil Painting',
      oilPaintingDesc: 'Classic oil painting texture',
      watercolor: 'Watercolor',
      watercolorDesc: 'Fresh watercolor style',
      cyberpunk: 'Cyberpunk',
      cyberpunkDesc: 'Futuristic sci-fi style',
      minimalist: 'Minimalist',
      minimalistDesc: 'Simple modern style',
    },
  },
  imageSearchPanel: {
    title: 'Image Search',
    subtitle: 'Find perfect materials for you',
    searchPlaceholder: 'Describe the image you need, intelligently match for you...',
    recommendedCategories: 'Recommended Categories',
    smartSuggestions: 'Smart Suggestions',
    searchResults: 'Search Results',
    backToSearch: 'Back to Search',
    resultsShown: 'images shown',
    searching: 'AI is searching for you...',
    importing: 'Importing...',
    use: 'Use',
    loadMore: 'Load More',
    loadingMore: 'Loading more images...',
    noResults: 'No related images found',
    tryDifferentKeywords: 'Try using different keywords',
    searchAgain: 'Search Again',
    allResultsShown: 'All results shown',
    categories: {
      landscape: 'Landscape',
      landscapeDesc: 'Natural scenery',
      abstract: 'Abstract',
      abstractDesc: 'Abstract art',
      business: 'Business',
      businessDesc: 'Business style',
      technology: 'Technology',
      technologyDesc: 'Tech feel',
      lifestyle: 'Lifestyle',
      lifestyleDesc: 'Life scenes',
      creative: 'Creative',
      creativeDesc: 'Creative design',
    },
    suggestions: {
      hdWallpaper: 'HD wallpaper background',
      productDisplay: 'Product display image',
      socialMedia: 'Social media materials',
      presentation: 'Presentation background',
      webBanner: 'Website banner image',
    },
  },
  transformPanel: {
    title: 'Transform',
    presets: 'Presets',
    parameters: 'Custom',
    reset: 'Reset',
    mixed: 'Mixed',
    matrix: {
      identity: 'Identity',
      identityDesc: 'No transformation',
      flipX: 'Flip X',
      flipXDesc: 'Horizontal flip',
      flipY: 'Flip Y',
      flipYDesc: 'Vertical flip',
      rotate90: 'Rotate 90°',
      rotate90Desc: 'Rotate 90 degrees',
      rotate180: 'Rotate 180°',
      rotate180Desc: 'Rotate 180 degrees',
      rotate270: 'Rotate 270°',
      rotate270Desc: 'Rotate 270 degrees',
      skewX: 'Skew X',
      skewXDesc: 'Skew horizontally',
      skewY: 'Skew Y',
      skewYDesc: 'Skew vertically',
      scaleUp: 'Scale Up',
      scaleUpDesc: 'Enlarge by 20%',
      scaleDown: 'Scale Down',
      scaleDownDesc: 'Shrink by 20%',
    },
  },
  imageEditor: {
    title: 'Image Editor',
    aspectRatio: 'Aspect Ratio',
    loading: 'Loading...',
    reset: 'Reset',
    saveChanges: 'Save Changes',
  },
  gradientPicker: {
    preview: 'Preview',
    type: 'Type',
    angle: 'Angle',
    colorStops: 'Color Stops',
    addStop: 'Add Stop',
    color: 'Color',
    colorValue: 'Color value',
    position: 'Position',
    linear: 'Linear',
    radial: 'Radial',
  },
  save: {
    saving: 'Saving...',
    saved: 'Saved',
    error: 'Save failed',
    unsaved: 'Unsaved changes',
  },
  shapePanel: {
    shape: 'Shape',
    selectShape: 'Select Shape',
    changeShapeDesc: 'Change shape for selected elements',
    rectangle: 'Rectangle',
    triangle: 'Triangle',
    circle: 'Circle',
  },
  borderPanel: {
    border: 'Border',
    customizeBorder: 'Customize border color and width',
  },
  clipPathPanel: {
    clipPath: 'Clip Path',
    none: 'None',
    triangle: 'Triangle',
    parallelogram: 'Parallelogram',
    leftTiltedParallelogram: 'Left Tilted Parallelogram',
    trapezoid: 'Trapezoid',
    star: 'Star',
    pentagon: 'Pentagon',
    hexagon: 'Hexagon',
    octagon: 'Octagon',
    circle: 'Circle',
    selectClipPath: 'Select Clip Path',
    applyClipPath: 'Apply clip path to selected elements',
  },
  chatPanel: {
    local: 'Local',
    global: 'Global',
    localEdit: 'Local Edit:',
    localEditDesc: 'Edit only the currently selected elements, keeping other content unchanged',
    globalEdit: 'Global Edit:',
    globalEditDesc: 'Modify and reorganize the entire page',
  },
  recentAssetPanel: {
    all: 'All',
    favorites: 'Favorites',
    noFavoriteAssets: 'No Favorite Assets',
    noRecentAssets: 'No Recent Assets',
    favoriteAssetsWillAppearHere: 'Your favorite assets will appear here',
    recentlyUsedAssetsWillAppearHere: 'Your recently used assets will appear here',
    today: 'Today',
    yesterday: 'Yesterday',
    removeFromFavorites: 'Remove from favorites',
    addToFavorites: 'Add to favorites',
  },
  frameMenu: {
    lockPage: 'Lock page',
    unlockPage: 'Unlock page',
    duplicatePage: 'Duplicate page',
    moreOptions: 'More options',
    moreActions: 'More actions',
    moveToTop: 'Move to top',
    moveUp: 'Move up',
    moveDown: 'Move down',
    moveToBottom: 'Move to bottom',
    deletePage: 'Delete page',
  },
  textFillMode: {
    default: 'Default',
    char: 'Character',
    line: 'Line',
  },
  shaderEditor: {
    shaderEffects: 'Dynamic Effects',
    effectType: 'Effect Type',
    presets: 'Presets',
    preset: 'Preset',
    enableAnimation: 'Enable Animation',
    disableAnimation: 'Disable Animation',
    generateRandomSeed: 'Generate Random Seed',
    resetParameters: 'Reset Parameters',
    moreSettings: 'More Settings',
    shaderEditorDisabled: 'Shader editor is disabled',
    addColor: 'Add',
    seed: 'Seed',
    speed: 'Speed',
    animated: 'Animated',
  },
  imageMenu: {
    aiImage: 'AI Image',
    icons: 'Icons',
    QRCode: 'QR Code',
    title: 'AI Image Editor',
    description: 'Edit your image with AI',
    modelOptions: {
      gemini: 'Gemini',
      openai: 'GPT-4o',
      comingSoon: 'Coming soon',
    },
    placeholder: 'Describe the image modifications you want...',
    generate: 'Edit Image',
    loading: 'Generating...',
    editImage: 'AI Image Edit',
    selectModel: 'Select Model',
  },
  iconMenu: {
    iconLibrary: 'Icon Library',
    searchIcons: 'Search icons...',
    allIcons: 'All Icons',
    noIconsFound: 'No icons found',
    iconsAvailable: 'icons available',
    loadingIcons: 'Loading icons...',
    selectIconSet: 'Select Icon Set',
    categories: {
      all: 'All',
      general: 'General',
      arrows: 'Arrows',
      arrow: 'Arrow',
      media: 'Media',
      ui: 'UI',
      business: 'Business',
      technology: 'Technology',
      social: 'Social',
      travel: 'Travel',
      food: 'Food',
      weather: 'Weather',
      sports: 'Sports',
      medical: 'Medical',
      education: 'Education',
      shopping: 'Shopping',
      communication: 'Communication',
      design: 'Design',
      finance: 'Finance',
      security: 'Security',
      entertainment: 'Entertainment',
      file: 'File',
      alert: 'Alert',
      health: 'Health',
      tools: 'Tools',
      people: 'People',
    },
  },
  unsplashPanel: {
    title: 'Images',
    description: 'Use high-quality visual materials',
    searchPlaceholder: 'Search beautiful images...',
    searchButton: 'Search',
    loadingImages: 'Finding beautiful images...',
    loadMore: 'Load More',
    loading: 'Loading...',
    noImages: 'No Images',
    noImagesDescription: 'Try adjusting your search keywords',
    browseSelected: 'Browse Selected Images',
    use: 'Use',
    emptyState: {
      title: 'No images found',
      description: 'Try adjusting your search keywords',
    },
    presets: {
      featured: 'Featured',
      nature: 'Nature',
      abstract: 'Abstract',
      texture: 'Texture',
      gradient: 'Gradient',
    },
  },
  quickEditMenu: {
    placeholder: 'Ask for quick changes...',
    loading: 'Processing...',
    send: 'Send',
    error: 'Failed to process request',
    presets: {
      aiQuickPresets: 'AI Quick Presets',
      textEditing: 'Text Editing',
      imageProcessing: 'Image Processing',
      shapeEffects: 'Shape Effects',
      rewrite: 'Rewrite',
      refine: 'Refine',
      professional: 'Professional',
      brand: 'Brand Tone',
      concise: 'Concise',
      translate: 'Translate',
      correct: 'Correct',
      expand: 'Expand',
      summary: 'Summary',
    },
    prompts: {
      rewrite: 'Rewrite this text, keeping the original meaning but using different expressions',
      refine: 'Refine this text, remove redundancy and keep core information',
      professional: 'Rewrite the text in a more professional tone',
      brand: 'Rewrite the text to be more brand-focused',
      concise: 'Rewrite the text to be more concise',
      translate: 'Translate the text to another language (Chinese to English, English to Chinese)',
      correct: 'Check and correct grammar and spelling errors in the text',
      expand: 'Expand this text with more details and content',
      summary: 'Generate a concise summary of this text',
    },
  },
  textAlign: {
    left: 'Left',
    center: 'Center',
    right: 'Right',
    justify: 'Justify',
  },
  helpCenter: {
    title: 'Help Center',
    description: 'Everything you need to master Seede Design',
    tabs: {
      shortcuts: 'Shortcuts',
      features: 'Features',
      tips: 'Tips',
    },
    shortcuts: {
      essential: {
        title: 'Essential',
        undo: 'Undo last action',
        redo: 'Redo last action',
        copy: 'Copy selected element',
        paste: 'Paste element',
        delete: 'Delete selected element',
        save: 'Save project',
      },
      selection: {
        title: 'Selection & Layers',
        selectAll: 'Select all elements',
        group: 'Group selected elements',
        ungroup: 'Ungroup selected elements',
        duplicate: 'Duplicate selected element',
        bringToFront: 'Bring to front',
        sendToBack: 'Send to back',
      },
      view: {
        title: 'View & Navigation',
        zoomToFit: 'Zoom to fit canvas',
        zoomIn: 'Zoom in',
        zoomOut: 'Zoom out',
        resetZoom: 'Reset zoom to 100%',
        pan: 'Pan canvas (hold and drag)',
      },
      text: {
        title: 'Text Editing',
        bold: 'Bold text',
        italic: 'Italic text',
        underline: 'Underline text',
        increaseFontSize: 'Increase font size',
        decreaseFontSize: 'Decrease font size',
      },
      help: {
        title: 'Help & Interface',
        openHelp: 'Open this help panel',
        closeDialogs: 'Close dialogs or deselect',
      },
    },
    features: {
      aiAssistant: {
        title: 'Smart AI Assistant',
        description:
          'Chat with AI to generate designs, modify elements, and get creative suggestions',
        tips: [
          'Ask for specific design changes',
          'Request color palette suggestions',
          'Get layout recommendations',
        ],
      },
      textTools: {
        title: 'Advanced Text Tools',
        description: 'Rich text editing with custom fonts, effects, and typography controls',
        tips: [
          'Choose fonts that best match your design',
          'Use text effects and shadows',
          'Apply gradient text fills',
        ],
      },
      imageProcessing: {
        title: 'Image Processing',
        description: 'Built-in image editing, background removal, and filter effects',
        tips: [
          'Remove backgrounds automatically',
          'Apply artistic filters',
          'Adjust brightness and contrast',
        ],
      },
      export: {
        title: 'Export Options',
        description: 'Export in multiple formats: PNG, JPG, PDF, SVG with custom dimensions',
        tips: [
          'Choose optimal format for your use case',
          'Set custom export dimensions',
          'Batch export multiple designs',
        ],
      },
      collaboration: {
        title: 'Collaboration',
        description: 'Share designs, collaborate in real-time, and manage project permissions',
        tips: ['Share via link', 'Set view/edit permissions', 'Track version history'],
      },
    },
    tips: {
      gettingStarted: {
        title: 'Getting Started',
        items: [
          'Start with a template and customize it to save time',
          'Use the AI chat to describe what you want to create',
          'Drag and drop images directly onto the canvas',
          'Double-click text elements to edit them quickly',
        ],
      },
      design: {
        title: 'Design Best Practices',
        items: [
          'Maintain consistent spacing between elements',
          'Use a limited color palette for cohesive designs',
          'Choose fonts that complement each other',
          'Keep important text readable with good contrast',
        ],
      },
      productivity: {
        title: 'Productivity Tips',
        items: [
          'Use keyboard shortcuts for faster workflow',
          'Group related elements for easier management',
          'Save frequently used elements as components',
          'Use the grid and alignment tools for precision',
        ],
      },
      advanced: {
        title: 'Advanced Techniques',
        items: [
          'Layer multiple effects for rich visual depth',
          'Use masks to create complex compositions',
          'Experiment with blend modes for unique effects',
          'Create custom color gradients for backgrounds',
        ],
      },
    },
    footer: {
      helpShortcut: 'to open this help',
      documentation: 'Need more help? Visit our documentation',
    },
  },
  createAssetPicker: {
    historyTitle: 'History',
    viewAll: 'View All',
    materialLibrary: 'Material Library',
    materialLibraryDesc: 'Select materials to add to your creation',
    loading: 'Loading...',
    loadingMaterials: 'Loading materials...',
    error: 'Failed to load',
    noMaterials: 'No materials',
    noMaterialsDesc: 'No materials available, uploaded items will appear here',
    showingAll: 'All materials displayed',
    retryLoad: 'Retry loading',
  },
  layerTree: {
    title: 'Layers',
    searchPlaceholder: 'Search layers...',
    showOnlyMatches: 'Show only matches',
    multiSelectMode: 'Multi-select mode',
    density: {
      standard: 'Standard',
      compact: 'Compact',
    },
    actions: {
      toggleLock: 'Toggle lock',
      toggleVisibility: 'Toggle visibility',
      bringForward: 'Bring forward',
      sendBackward: 'Send backward',
      expand: 'Expand',
      collapse: 'Collapse',
      dragToReorder: 'Drag to reorder',
      hideLayer: 'Hide layer',
      showLayer: 'Show layer',
      lockLayer: 'Lock layer',
      unlockLayer: 'Unlock layer',
    },
    contextMenu: {
      rename: 'Rename',
      duplicate: 'Duplicate',
      delete: 'Delete',
      group: 'Group',
      ungroup: 'Ungroup',
      bringToFront: 'Bring to Front',
      sendToBack: 'Send to Back',
    },
    messages: {
      cannotMoveToDescendant: 'Cannot move a layer into its own descendant.',
      confirmCrossFrameMove: 'Moving layers across frames may affect layout. Continue?',
      moveConfirm: 'Move',
      moveCancel: 'Cancel',
    },
    palette: {
      searchPlaceholder: 'Search actions...',
      noResults: 'No matching actions found',
    },
    shortcuts: {
      multiSelect: 'Hold Cmd/Ctrl to multi-select',
      rangeSelect: 'Hold Shift to range select',
      toggleExpand: 'Double-click to expand/collapse',
    },
    dropActions: {
      parentLocked: 'Parent is locked, cannot drop here.',
      parentHidden: 'Parent is hidden, cannot drop here.',
    },
  },
  strokePanel: {
    stroke: 'Stroke',
    border: 'Border',
    customizeBorder: 'Customize border styles',
    quickStyles: 'Quick Styles',
    color: 'Color',
    width: 'Width',
    dash: 'Dash',
    dashPattern: 'Dash Pattern',
    lineCap: 'Line Cap',
    lineJoin: 'Line Join',
    miterLimit: 'Miter Limit',
    presets: {
      none: 'None',
      thin: 'Thin',
      medium: 'Medium',
      thick: 'Thick',
      dashed: 'Dashed',
      dotted: 'Dotted',
    },
    lineCaps: {
      butt: 'Butt',
      round: 'Round',
      square: 'Square',
    },
    lineJoins: {
      miter: 'Miter',
      round: 'Round',
      bevel: 'Bevel',
    },
    placeholders: {
      dashPattern: 'e.g. 5,5 or 10,5,3,5',
      selectLineCap: 'Select line cap',
      selectLineJoin: 'Select line join',
      mixed: 'Mixed',
    },
  },
  editPanel: {
    searchPlaceholder: 'Search elements by name, text, or type...',
    clearSearch: 'Clear search',
    locateElement: 'Locate element',
    noEditableElements: 'No editable elements',
    elementsWillAppear: 'Elements will appear here when available',
    noMatchingElements: 'No matching elements',
    adjustSearchTerms: 'Try adjusting your search terms or clear the search to see all elements',
    noFramesFound: 'No frames found',
    importDesignFile: 'Import a design file to start editing your content',
    enterText: 'Enter text...',
    uploadImage: 'Upload image',
    element: 'Element',
    frame: 'Frame',
  },
  workspaceAsset: {
    all: 'All',
    favorites: 'Favorites',
    recent: 'Recently uploaded',
    ai: 'AI generated',
    searchAssets: 'Search assets...',
    upload: 'Upload',
    select: 'Select',
    cancel: 'Cancel',
    selectedCount: '{{count}} selected',
    selectAll: 'Select All',
    clearSelection: 'Clear Selection',
    delete: 'Delete',
    confirmBatchDelete:
      'Are you sure you want to delete {count} assets? This action cannot be undone.',
    loadingAssets: 'Loading assets...',
    emptyTitle: 'Your asset library is empty',
    emptyDescription: 'Upload your first asset to start building your creative media collection',
    uploadAsset: 'Upload Asset',
    loadingMore: 'Loading more...',
    noSearchResults: 'No assets match your search',
    noSearchResultsDescription:
      "We couldn't find any assets for “{{query}}”. Try a different keyword or upload a new asset.",
    somethingWentWrong: 'Something went wrong',
    tryAgain: 'Try Again',
    uploadFailed: 'Upload failed',
  },
  pageListPanel: {
    pages: 'Pages',
    addPage: 'Add page',
    duplicatePage: 'Duplicate page',
    deletePage: 'Delete page',
    pageActions: 'Page actions',
    page: 'Page',
  },
  filterPanel: {
    filter: 'Filter',
    presets: 'Presets',
    custom: 'Custom',
    filterType: 'Filter Type',
    intensity: 'Intensity',
    filterValue: 'Filter Value',
    none: 'None',
    grayscale: 'Grayscale',
    sepia: 'Sepia',
    blur: 'Blur',
    brightness: 'Brightness',
    contrast: 'Contrast',
    invert: 'Invert',
    saturate: 'Saturate',
    placeholder: 'e.g. blur(5px) brightness(120%)',
  },
  about: {
    title: 'About Us',
    subtitle:
      'Everyone carries a seed of creativity within, and it deserves to be nurtured, sprouted, and flourished',
    vision: {
      title: 'Vision',
      content: [
        'We believe AI will redefine the boundaries of creation. In the future, everyone will be able to transform ideas into beautiful visual works through simple conversation.',
        'Seede AI is committed to becoming a bridge between imagination and reality, making design accessible to everyone rather than a skill reserved for the few.',
      ],
    },
    mission: {
      title: 'Mission',
      content: [
        'Lower the barrier to design, enabling everyone to create professional-grade visual content with ease.',
        'Continuously optimize AI models and user experience to provide smarter, more efficient, and more creative design solutions.',
        'Build an open and friendly creative community where inspiration collides and grows.',
      ],
    },
    values: {
      title: 'Values',
      content: [
        "Creativity First: It's all about the ideas.",
        'Simplicity Matters: The best ideas are simple.',
        'Personalization is Power: Your design, your way.',
        "Design for Everyone: It's not just about the design, it's about the connection.",
        "From Content to Connection: From content to connection, we're here to help you create the perfect design.",
      ],
    },
    story: {
      title: 'Story',
      content: [
        "I'm Evan, founder of Seede AI. Many people ask me why I chose to create AI design tools. My story might be different from what many expect.",
        'I\'ve been obsessed with "creating" since childhood. In high school, I built and maintained a local forum called "Deyang Forum" all by myself. I didn\'t know much about technology then, just some basic PHP, but when I saw users actually using my product, and some even mistook it for "officially operated," that sense of achievement made me feel the human warmth behind technology for the first time.',
        'I chose cybersecurity in college and won some awards, but gradually realized what I truly loved wasn\'t "hacking and defense," but "building things from scratch." So in my sophomore year, I chose to leave campus and enter the real industry to learn and grow.',
        "During my time at Meituan, deeply inspired by Serverless concepts and Vercel, I independently designed and implemented a mini version of the Vercel system from scratch. That was my first time truly transitioning from pure technical architecture to building solutions with product thinking. This experience made me deeply realize: Technology itself isn't the endpoint; creating smooth, efficient experiences for users is the core.",
        "After leaving Meituan, I joined the startup Dora AI, officially entering the design tools field. I invested significant time deeply studying Figma and Canva, not just as a user, but from a product builder's perspective, understanding the architectural logic, interaction concepts, and implementation paths behind modern design tools. That was my first systematic understanding that design tools are essentially about helping people express ideas more freely, and technology should serve this goal. After ChatGPT's release, I became even more convinced: AI will inevitably reshape the future of design.",
        'Thus, Seede AI was born. The name "Seede" comes from combining "Seed" and "Design." We believe everyone carries a seed of creativity within, and it deserves to be nurtured, sprouted, and flourished—not hindered by complex technology and tools.',
        'Today, Seede AI is committed to building such a product: You need no design background, just input your ideas, and AI will help you generate beautiful and practical images, posters, invitations, infographics... Especially in text and information design, we continuously optimize layout control and visual effects, hoping to enable every user to express themselves with ease and confidence.',
        "To me, technology has never been just code and models; it's a bridge to humanity. We're still in the early stages with much to improve, but I firmly believe: True technology should make people more free, more confident, and more creative.",
        'Looking forward to building a more intelligent and open design world together with you. —— Evan, Founder of Seede AI',
      ],
    },
  },
  order: {
    title: 'Orders',
    loadingOrders: 'Loading orders...',
    noOrdersFound: 'No orders found',
    failedToLoadOrders: 'Failed to load orders',
    noMoreOrders: 'No more orders',
    id: 'ID',
    date: 'Date',
    details: 'Details',
    amount: 'Amount',
    status: 'Status',
    paymentMethod: {
      alipay: 'Alipay',
      wxpay: 'WeChat Pay',
      gift: 'Gift',
      creditCard: 'Credit Card',
      payment: 'Payment',
    },
    statusLabels: {
      succeeded: 'Succeeded',
      paid: 'Paid',
      complete: 'Complete',
      pending: 'Pending',
      processing: 'Processing',
      failed: 'Failed',
      cancelled: 'Cancelled',
    },
  },
};
